// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:41.126Z
// Property: The Reserve at Elm (ID: 6767906449165635)
// Collections: 26 amenities, 6 floorplans (live), 62 photos, 66 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165635",
  "property_external_id": "ryh1pz3",
  "property_zillow_url": "https://www.zillow.com/apartments/jenks-ok/the-reserve-at-elm/5hQvgB/",
  "property_apartments_url": "https://www.apartments.com/the-reserve-at-elm-jenks-ok/ryh1pz3/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Reserve+at+Elm/data=!4m2!3m1!1s0x0:0x81bcce5f666eb8cf?sa=X&ved=2ahUKEwiQloStgb2SAxUitokEHa0wKpcQ_BJ6BAgSEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-reserve-at-elm",
  "property_name": "The Reserve at Elm",
  "property_website_url": "https://www.caseusa.com/apartments/ok/jenks/reserve-at-elm/",
  "property_domain": null,
  "property_address": "701 West 101st Pl. South",
  "property_full_address": "701 West 101st Pl. South, Jenks, OK, 74037",
  "property_address_1": "701 West 101st Pl. South",
  "property_address_2": null,
  "property_address_city": "Jenks",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74037",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa County",
  "property_address_latitude": "36.0192",
  "property_address_longitude": "-95.9798",
  "property_email": "reserveatelm@caseusa.com",
  "property_phone": "(918) 246-6510",
  "property_call_tracking_phone": "844-493-0509",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At The Reserve at Elm in Jenks, Oklahoma, each thoughtfully designed one and two-bedroom floor plan offers modern living with luxurious amenities. Enjoy resort-style features like a sparkling pool, fitness center, and dog park, all within a gated community. Your ideal apartment awaits—schedule a tour or browse our availability today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Discover Your Dream Home at The Reserve at Elm in Jenks, Oklahoma!**\n\nWelcome to The Reserve at Elm, an exceptional apartment community offering a variety of stylish floor plans, including cozy one-bedroom and spacious two-bedroom layouts. Nestled in the heart of Jenks, our community seamlessly blends comfort, convenience, and charm, making it the ideal place to call home.\n\nAt The Reserve at Elm, enjoy an array of top-notch amenities designed to enhance your lifestyle. Dive into our refreshing pool, stay fit in our well-equipped fitness center, or unwind in our welcoming clubhouse. With controlled access and a dedicated property management team on-site, your peace of mind is our priority. Plus, we offer convenient online services and package deliveries to streamline your day-to-day living.\n\nYou'll love our beautifully landscaped courtyards, sundeck, and picnic area, perfect for enjoying the outdoors with family and friends. Let your furry friends romp in our pet play area and dog park, while you take advantage of our business center and guest apartment for visitors. \n\nInside your new home, experience modern comforts with a fully-equipped kitchen featuring stainless steel appliances, spacious walk-in closets, and laundry facilities including a washer/dryer. Enjoy stunning views from your private balcony or patio and cozy nights by the fireplace.\n\nDon't wait — find your new home today! Browse our availability or schedule a tour to visit our vibrant community at The Reserve at Elm. Your perfect living space awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb49-8ebd-742a-a896-552a382109da.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by lush landscaping and apartment buildings.",
    "public_id": "019cfb49-8ebd-742a-a896-552a382109da",
    "storage_key": "property/6767906449165635/019cfb49-8ebd-742a-a896-552a382109da.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "260",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "pets up to 40 pounds",
  "property_pet_policy_description": "Above refers to pets up to 40 pounds",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://reserveatelmapartmentstulsa.securecafe.com/onlineleasing/the-reserve-at-elm/floorplans.aspx",
  "property_resident_portal_url": "https://reserveatelmapartmentstulsa.securecafe.com/residentservices/the-reserve-at-elm/userlogin.aspx",
  "property_apply_now_url": "https://reserveatelmapartmentstulsa.securecafe.com/onlineleasing/the-reserve-at-elm/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb49-e29d-7189-adfd-bf7995830945.webp",
  "property_primary_logo_media": {
    "alt_text": "The Reserve at Elm Urban Apartments logo",
    "public_id": "019cfb49-e29d-7189-adfd-bf7995830945",
    "storage_key": "property/6767906449165635/019cfb49-e29d-7189-adfd-bf7995830945.webp",
    "width": 615,
    "height": 145
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-c836-758d-8136-276c8bd04a25.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb4a-c836-758d-8136-276c8bd04a25",
    "storage_key": "property/6767906449165635/019cfb4a-c836-758d-8136-276c8bd04a25.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-d62e-777f-b71c-d8d8c106cb1d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Reserve at Elm Urban Apartments logo",
    "public_id": "019cfb4a-d62e-777f-b71c-d8d8c106cb1d",
    "storage_key": "property/6767906449165635/019cfb4a-d62e-777f-b71c-d8d8c106cb1d.webp",
    "width": 615,
    "height": 145
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-e570-75ea-b4db-6fb9ccc9cc2f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Reserve at Elm Urban Apartments logo",
    "public_id": "019cfb4a-e570-75ea-b4db-6fb9ccc9cc2f",
    "storage_key": "property/6767906449165635/019cfb4a-e570-75ea-b4db-6fb9ccc9cc2f.webp",
    "width": 615,
    "height": 145
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#b9975b",
  "property_secondary_color": "#4e5147",
  "property_font_color": null,
  "property_color_4": "#2f2f30",
  "property_color_3": "#2f2f30",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1176",
  "property_sqft_min": "789",
  "property_sqft_max": "1176",
  "property_price_range": "1169 - 1684",
  "property_price_min": "1169",
  "property_price_max": "1684",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/TheReserveAtElm/photos/d41d8cd9/1489949796472277/",
  "property_instagram_url": "https://www.instagram.com/reserveatelm/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ37jgmZKRtocRz7huZl_OvIE",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Jenks%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/@reserve_at_elm?lang=en",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Reserve at Elm",
  "property_home_romance_title": "Embrace a Life of Comfort and Community Here",
  "property_home_amenities_blurb": "Welcome to The Reserve at Elm in Jenks, Oklahoma, where modern living meets comfort. Enjoy spacious one and two-bedroom floor plans featuring elegant touches like vaulted ceilings and stainless steel appliances. Our vibrant community offers a refreshing pool, a relaxing clubhouse, and a dog park, perfect for both relaxation and recreation.",
  "property_home_floorplans_blurb": "Welcome to The Reserve at Elm in Jenks, Oklahoma, where comfort meets elegance. Choose from expertly designed one and two-bedroom apartments tailored to suit your lifestyle. Each home is a canvas for your unique living experience. Browse through our available floor plans and find the perfect space to call your own!",
  "property_home_gallery_blurb": "At The Reserve at Elm in Jenks, Oklahoma, luxury meets comfort in our thoughtfully designed one and two-bedroom apartments. With enticing amenities like a sparkling pool, pet-friendly areas, and a state-of-the-art fitness center, your ideal living experience begins here. Picture yourself living in a community that feels like home.",
  "property_home_neighborhood_blurb": "Nestled in the heart of Jenks, Oklahoma, The Reserve at Elm offers a vibrant neighborhood filled with local favorites and unique attractions. Embrace the charm of your surroundings and uncover nearby points of interest that enhance your living experience. Dive into the local scene today—there's so much to enjoy!",
  "property_home_reviews_blurb": "At The Reserve at Elm in Jenks, Oklahoma, experience a harmonious blend of urban charm and serene living. Residents rave, \"My apartment is as beautiful as it is quiet,\" and appreciate the friendly office staff and 24/7 gym access. Join our vibrant community and see what our residents love!",
  "property_neighborhood_blurb": "At The Reserve at Elm in Jenks, Oklahoma, vibrant community life awaits! With convenient access to renowned educational institutions like Oral Roberts University and local schools, residents can enjoy both comfort and connectivity. Dive into nearby parks, playgrounds, and cultural landmarks—your ideal home is just a heartbeat away. See what’s around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Reserve at Elm in Jenks, Oklahoma, experience modern living with a host of exceptional amenities. Dive into our sparkling pool, stay fit in the state-of-the-art fitness center, or unwind in the clubhouse. With spacious one and two-bedroom layouts, every detail is designed for your comfort and style.",
  "property_applynow_blurb": "At The Reserve at Elm in Jenks, Oklahoma, find your perfect sanctuary with spacious one and two-bedroom floor plans. Enjoy resort-style amenities like a sparkling pool, energizing fitness center, and a charming dog park, all while relishing the comfort of your modern apartment. Lease online today and welcome home!",
  "property_contactus_blurb": "At The Reserve at Elm in Jenks, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Embrace comfort and community in a welcoming environment. Have questions? Contact our leasing team today and let us help you find your perfect home!",
  "property_faqs_blurb": "At The Reserve at Elm in Jenks, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Have questions? Our FAQs page provides essential insights into community living, making it easy for you to envision your perfect home. Start your journey today!",
  "property_floorplans_blurb": "At The Reserve at Elm in Jenks, Oklahoma, your ideal living space awaits. Choose from stylish one- and two-bedroom floor plans designed with modern comforts and thoughtful details. Embrace a lifestyle of convenience and charm—browse our available apartment homes to uncover the perfect floor plan tailored just for you.",
  "property_gallery_blurb": "At The Reserve at Elm in Jenks, Oklahoma, envision a vibrant lifestyle filled with resort-style amenities. From sun-soaked days by the pool to cozy evenings in your loft with stainless steel appliances, each corner of our community offers comfort and convenience. Picture yourself living here—your sanctuary awaits!",
  "property_interactivemap_blurb": "Welcome to The Reserve at Elm in Jenks, Oklahoma, where your ideal apartment awaits! Choose from spacious one and two-bedroom layouts featuring modern amenities like a refreshing pool, a state-of-the-art fitness center, and serene outdoor spaces. Use our interactive community map to envision your new lifestyle today!",
  "property_pets_blurb": "Welcome to The Reserve at Elm in Jenks, OK, where modern living meets suburban tranquility. Our apartment community embraces your furry friends—pets up to 40 pounds are happily welcomed! Experience stylish interiors, lush landscapes, and a vibrant community, all just moments from local shops and dining. Your ideal home awaits!",
  "property_referafriend_blurb": "At The Reserve at Elm in Jenks, Oklahoma, your perfect living space awaits! Whether you’re seeking a cozy one-bedroom or a spacious two-bedroom, our thoughtfully designed floor plans cater to diverse lifestyles. Invite a friend to join your community; great friends make great neighbors. Share the love today!",
  "property_residentaccess_blurb": "Welcome to The Reserve at Elm in Jenks, Oklahoma, where comfort meets convenience. Whether you’re enjoying a cozy one-bedroom or sharing space in our spacious two-bedroom, our community enhances your lifestyle. Access your resident portal now to effortlessly manage rent payments, request maintenance, and enjoy seamless living at its finest!",
  "property_reviews_blurb": "At The Reserve at Elm in Jenks, Oklahoma, residents delight in a harmonious blend of beauty and urban charm. With a 5-star rating, one resident praises the \"quiet\" yet \"beautiful\" apartments, the \"friendly office staff,\" and the 24/7 gym. Join a community that feels like home—see what our residents have to say!",
  "property_created_at": "1753982394754",
  "property_scheduletour_blurb": "At The Reserve at Elm in Jenks, Oklahoma, your perfect home awaits with our variety of one and two-bedroom floor plans. Immerse yourself in a vibrant community where comfort meets convenience. Schedule a tour today and see what our residents love most about their living experience!",
  "property_thankyou_blurb": "Thank you for your interest in The Reserve at Elm, where contemporary living meets comfort in Jenks, Oklahoma. With thoughtfully designed one and two-bedroom floor plans, your perfect home awaits. Stay tuned, as a dedicated team member will be in touch soon to guide you on your journey to luxury living!",
  "property_virtualtours_blurb": "At The Reserve at Elm in Jenks, Oklahoma, our thoughtfully designed one and two-bedroom apartments offer a perfect blend of comfort and style. Immerse yourself in our inviting community—take a virtual tour and envision your new home today! Your ideal lifestyle awaits just a click away.",
  "property_copyright": "2025 All Rights Reserved. The Reserve at Elm",
  "property_seo_title_home": "The Reserve at Elm | Apartments in Jenks, Oklahoma",
  "property_seo_description_home": "Experience unrivaled living at The Reserve at Elm in Jenks, OK! Choose from spacious floor plans, indulge in top-tier amenities, and find your perfect home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Jenks, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal space at The Reserve at Elm in Jenks, OK. From cozy one-bedrooms to spacious two-bedrooms, browse our floor plans tailored for you!",
  "property_seo_title_amenities": "Amenities | Jenks, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience The Reserve at Elm in Jenks, OK—where luxurious amenities like a pool, fitness center, and dog park meet stylish living spaces. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Jenks, Oklahoma",
  "property_seo_description_gallery": "Experience life at The Reserve at Elm in Jenks, OK, where luxury meets comfort. Enjoy top-tier amenities, stunning views, and your dream apartment layout!",
  "property_seo_title_virtualtours": "Virtual Tours | The Reserve at Elm Apartments",
  "property_seo_description_virtualtours": "Experience upscale living at The Reserve at Elm in Jenks, OK. Take a virtual tour of our stylish one and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | The Reserve at Elm Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at The Reserve at Elm in Jenks, OK! Relax by the pool, work out in our fitness center, or enjoy the convenience of online services.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Jenks, Oklahoma",
  "property_seo_description_neighborhood": "\"Uncover the charm of Jenks, Oklahoma at The Reserve at Elm. From cozy coffee shops to scenic parks, find your local favorites just steps away!\"",
  "property_seo_title_contact": "Contact Us | The Reserve at Elm",
  "property_seo_description_contact": "Experience luxury living at The Reserve at Elm in Jenks, OK. With spacious one and two-bedroom floor plans, your perfect home awaits! Have questions? Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Jenks, Oklahoma",
  "property_seo_description_faqs": "Uncover your ideal living at The Reserve at Elm in Jenks! From pools to pet parks, our FAQs page answers all your questions about our vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Jenks, Oklahoma",
  "property_seo_description_reviews": "\"Uncover the charm of The Reserve at Elm in Jenks, OK. Our residents love the inviting amenities, floor plans, and vibrant community. Hear their stories today!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Jenks, Oklahoma",
  "property_seo_description_applynow": "Unlock comfort at The Reserve at Elm in Jenks, OK! Enjoy upscale amenities, a serene courtyard, and stunning layouts. Your perfect apartment awaits!",
  "property_seo_title_residentaccess": "Resident Access | The Reserve at Elm",
  "property_seo_description_residentaccess": "Unlock convenient living at The Reserve at Elm! Log in to your resident portal for easy rent payments, maintenance requests, and community updates in Jenks, OK.",
  "property_seo_title_referafriend": "Refer A Friend | The Reserve at Elm",
  "property_seo_description_referafriend": "\"Great friends make the best neighbors! Refer a friend to The Reserve at Elm in Jenks, OK, and enjoy vibrant living together in our welcoming community.\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Reserve at Elm",
  "property_seo_description_scheduletour": "Experience luxury living at The Reserve at Elm in Jenks, Oklahoma. Schedule a tour today and envision your new home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | The Reserve at Elm",
  "property_seo_description_privacy": "Your privacy matters at The Reserve at Elm. Learn how we protect your information while you enjoy life in beautiful Jenks, Oklahoma. View our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Reserve at Elm",
  "property_seo_description_accessibility": "Embrace seamless living at The Reserve at Elm in Jenks, OK. Our commitment to accessibility ensures everyone feels at home. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | The Reserve at Elm",
  "property_seo_description_sitemap": "Navigate your way through The Reserve at Elm in Jenks, OK! Our sitemap holds everything you need to know about your future home. Dive in today!",
  "property_seo_title_thankyou": "Thank You | The Reserve at Elm",
  "property_seo_description_thankyou": "Thank you for reaching out to The Reserve at Elm! Our team will connect soon to help you find your perfect home in vibrant Jenks, Oklahoma. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jenks, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865989437",
  "amenities": [
    {
      "id": "ec_0f6ebd679b9b878bec3d695c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397316",
      "title": "Private Gated Access Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0da949c0440a97c8e77f4d48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397317",
      "title": "Resort-Style Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49843bb3945f775be7d472f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397318",
      "title": "24 Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bd36fe986386074ab7c1299",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397319",
      "title": "Modern Business Center With Work Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec6121a46d49960960c6dbef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397320",
      "title": "Outdoor Lounge with Fireplace & Grilling Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd2e9a631259939af8c7da93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397321",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b7a938a906c61201c4dfee7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127432134",
      "title": "Pet Friendly Community with On-Site Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0de3346c9788dc3a3dde79cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397326",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_585a2a984f5dda93385de6db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127432136",
      "title": "Electronic Online Payment Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77bb6d66b86298c69751f400",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397328",
      "title": "24 Hour Emergency Maintenance Availability",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53e8238d0373a16265526fc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127432137",
      "title": "Complimentary Coffee Bar in Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9eebc4cbe3da0c9fd96fc713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "128033173",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b0b9bdd0d5f531ab08cd6f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397329",
      "title": "Professional On-Site Maintenance Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4705d9b629d86fe04a2bf3a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127397330",
      "title": "Friendly On-Site Management Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d335c39db649023ebc8fe8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "128042550",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d7d11d89a081b52cd4709c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127398774",
      "title": "Central Air Conditioning for Year-Round Comfort",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c232d707b9c243cc87e1cbf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127398775",
      "title": "In-Home Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a47aa3e5ae5b823d6a6fa88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127398776",
      "title": "Cozy Wood-Burning Fireplace in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16c0eefb0c900ad218e8b226",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127398777",
      "title": "Ceiling Fans for Added Comfort & Energy Efficiency",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9d4ae6a6ea8636b6845e5b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127398778",
      "title": "Private Patio or Balcony in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80c3b04b8f3697239539e98f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127398780",
      "title": "Side-by-side Fridge & Freezer with Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d34fa7c327b72f58a966c17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127398781",
      "title": "Spacious Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9be52de74ce20e74edc0e425",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127432195",
      "title": "Fully Equipped Kitchen with Modern Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04fe66818932a5977f965441",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127432205",
      "title": "Pantry Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c42960c107600b320ece9792",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127432207",
      "title": "Open-Concept Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88bd78dd90231ce5cb67df28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "yardi",
      "external_id": "127432208",
      "title": "Pool View Available in Select Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0b0f61df-a64c-470f-8803-764e4e910be7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc0a-0472-744a-a957-aae73b98e40f.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and large window.",
        "public_id": "019ecc0a-0472-744a-a957-aae73b98e40f",
        "storage_key": "property/6767906449165635/019ecc0a-0472-744a-a957-aae73b98e40f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with plush bedding, a modern ceiling fan, and a large window providing natural light.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_27322e2f-50cc-42a1-b568-d9b81eae08db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc0a-026c-76b9-b93f-61890898f041.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and decorative wall hangings.",
        "public_id": "019ecc0a-026c-76b9-b93f-61890898f041",
        "storage_key": "property/6767906449165635/019ecc0a-026c-76b9-b93f-61890898f041.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish bathroom vanity featuring a modern sink, large mirror, and unique woven wall art. Ample counter space and storage enhance functionality.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and decorative wall hangings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60fb01f4-8d95-4662-a3d7-0cf9611a65ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-fd8c-776c-80b9-a1a611d83829.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and bathtub with a shower curtain.",
        "public_id": "019ecc09-fd8c-776c-80b9-a1a611d83829",
        "storage_key": "property/6767906449165635/019ecc09-fd8c-776c-80b9-a1a611d83829.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a spacious vanity with a sink, a toilet, and a bathtub with a shower. The modern design includes updated fixtures and stylish decor.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and bathtub with a shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9782125-ce80-429b-9ac4-15e2e4ad7e30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-f80f-703f-9c33-dbc4db6090a4.webp",
      "image_media": {
        "alt_text": "A stylish living room with a brown sofa, coffee table, and TV.",
        "public_id": "019ecc09-f80f-703f-9c33-dbc4db6090a4",
        "storage_key": "property/6767906449165635/019ecc09-f80f-703f-9c33-dbc4db6090a4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush brown sofa, a modern coffee table, and entertainment center, perfect for relaxation and gatherings.",
      "link": "",
      "alt_text": "A stylish living room with a brown sofa, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3de97d1-6f09-4a3b-854a-9fb2214cb9fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-f19f-7265-84a3-182dc5c3476b.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, and a living area with a chair.",
        "public_id": "019ecc09-f19f-7265-84a3-182dc5c3476b",
        "storage_key": "property/6767906449165635/019ecc09-f19f-7265-84a3-182dc5c3476b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy meals or relax in this inviting dining and living space, featuring a stylish dining set and comfortable seating.",
      "link": "",
      "alt_text": "Dining area with table and chairs, and a living area with a chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_65a2cbbc-02c0-4ffb-bb04-b69c36d3048a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-bbc1-74dc-9849-4a5a1b253f40.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and TV.",
        "public_id": "019ecc09-bbc1-74dc-9849-4a5a1b253f40",
        "storage_key": "property/6767906449165635/019ecc09-bbc1-74dc-9849-4a5a1b253f40.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, entertainment center, and comfortable seating, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with fireplace and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16017642-1435-4bd3-a024-b3fccf9c74fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-ec67-71bb-845f-5a2ceb8ad34b.webp",
      "image_media": {
        "alt_text": "Modern living room with a comfortable sofa, coffee table, and entertainment center.",
        "public_id": "019ecc09-ec67-71bb-845f-5a2ceb8ad34b",
        "storage_key": "property/6767906449165635/019ecc09-ec67-71bb-845f-5a2ceb8ad34b.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Enjoy relaxing evenings in this stylish living room, featuring a plush sofa, a sleek coffee table, and a large entertainment center for all your media needs.",
      "link": "",
      "alt_text": "Modern living room with a comfortable sofa, coffee table, and entertainment center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7bc6b2a-a6c4-4ffe-8b4d-b562c94ea9e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-eae1-729a-8c0e-a02dffb17224.webp",
      "image_media": {
        "alt_text": "Kitchen and living room in an apartment with a L-shaped sofa and large windows.",
        "public_id": "019ecc09-eae1-729a-8c0e-a02dffb17224",
        "storage_key": "property/6767906449165635/019ecc09-eae1-729a-8c0e-a02dffb17224.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious kitchen and living area with modern appliances and comfortable seating. Enjoy an open-concept layout perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen and living room in an apartment with a L-shaped sofa and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c79b050-5b56-4646-90f8-63e5d12fb794",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-e83c-730b-89cc-964b8a346f65.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and custom cabinetry.",
        "public_id": "019ecc09-e83c-730b-89cc-964b8a346f65",
        "storage_key": "property/6767906449165635/019ecc09-e83c-730b-89cc-964b8a346f65.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, stainless steel appliances, and ample cabinet space for all your storage needs.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and custom cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_df01507c-04ab-48b9-b659-2f0f2224a13c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-dd83-710a-b8df-3ca4bfec8cb1.webp",
      "image_media": {
        "alt_text": "Living and dining room with a large sofa, coffee table, and dining set.",
        "public_id": "019ecc09-dd83-710a-b8df-3ca4bfec8cb1",
        "storage_key": "property/6767906449165635/019ecc09-dd83-710a-b8df-3ca4bfec8cb1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, modern coffee table, and an elegant dining set, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living and dining room with a large sofa, coffee table, and dining set.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_91f1a107-ea5a-4f2a-9623-6c93fecd577c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-eb0f-7367-9058-8a1af18f0315.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019ecc09-eb0f-7367-9058-8a1af18f0315",
        "storage_key": "property/6767906449165635/019ecc09-eb0f-7367-9058-8a1af18f0315.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Discover the heart of your home in this beautifully appointed kitchen, featuring ample cabinet space, modern stainless steel appliances, and elegant granite countertops.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20fbc037-ff7a-489e-8a74-2ed6a99a8d4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-d178-778a-86af-4dc82729674d.webp",
      "image_media": {
        "alt_text": "A well-lit office nook with a desk and chair by a window.",
        "public_id": "019ecc09-d178-778a-86af-4dc82729674d",
        "storage_key": "property/6767906449165635/019ecc09-d178-778a-86af-4dc82729674d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Create your ideal home office in this bright and airy nook, perfect for working or studying from home.",
      "link": "",
      "alt_text": "A well-lit office nook with a desk and chair by a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b037144-f124-4d57-ac5f-572294568a1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-e3ef-70be-b4ea-76b6c7f4227b.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with a modern kitchen island and bar seating.",
        "public_id": "019ecc09-e3ef-70be-b4ea-76b6c7f4227b",
        "storage_key": "property/6767906449165635/019ecc09-e3ef-70be-b4ea-76b6c7f4227b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious open-concept living, dining, and kitchen area featuring a large kitchen island with bar seating, perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Open concept living and dining area with a modern kitchen island and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7e04ed44-9b46-4656-9262-f041d60f52d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-dc64-74bc-ad14-7bb390f8532a.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, sink, mirror, and decorative plants.",
        "public_id": "019ecc09-dc64-74bc-ad14-7bb390f8532a",
        "storage_key": "property/6767906449165635/019ecc09-dc64-74bc-ad14-7bb390f8532a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Elegant bathroom vanity featuring a marble-look countertop, undermount sink, and ample storage. Decorated with fresh greenery for a spa-like feel.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, sink, mirror, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02494b1f-4701-4a83-996d-4c1ad3f04332",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-c10c-7109-a4f6-adacd52c4d24.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, plush bedding, a ceiling fan, and a closet.",
        "public_id": "019ecc09-c10c-7109-a4f6-adacd52c4d24",
        "storage_key": "property/6767906449165635/019ecc09-c10c-7109-a4f6-adacd52c4d24.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax and unwind in the master bedroom. This spacious room features a comfortable queen-sized bed, ample closet space, and a ceiling fan for your comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, plush bedding, a ceiling fan, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2338cf29-f43b-40a5-92ea-0fe67b8311ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-bf04-711d-a8b9-e3f47a4e105d.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs. A desk and chair are visible by the window.",
        "public_id": "019ecc09-bf04-711d-a8b9-e3f47a4e105d",
        "storage_key": "property/6767906449165635/019ecc09-bf04-711d-a8b9-e3f47a4e105d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy dining area featuring a stylish round table with black chairs. Adjacent to a window-lit desk area, perfect for a home office setup.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs. A desk and chair are visible by the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8d01a2c7-33b0-442e-b58f-315a7a3190a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-c07c-70de-afd5-99666debaf89.webp",
      "image_media": {
        "alt_text": "Living room and dining area with fireplace and windows.",
        "public_id": "019ecc09-c07c-70de-afd5-99666debaf89",
        "storage_key": "property/6767906449165635/019ecc09-c07c-70de-afd5-99666debaf89.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a cozy fireplace, comfortable seating, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Living room and dining area with fireplace and windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72d28ac8-dcde-403e-b198-eb800ed00e6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-bdd6-72d9-a80b-6f7f71c9d81e.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with a plush white sofa, round dining table, and a desk.",
        "public_id": "019ecc09-bdd6-72d9-a80b-6f7f71c9d81e",
        "storage_key": "property/6767906449165635/019ecc09-bdd6-72d9-a80b-6f7f71c9d81e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and stylish living area, perfect for relaxing or entertaining. Features a comfortable sofa, dining table, and a dedicated workspace.",
      "link": "",
      "alt_text": "Modern living and dining area with a plush white sofa, round dining table, and a desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99774251-eb04-484f-be03-84bdbd1ca5f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-c7d6-7473-b339-d0ee44ee51a9.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019ecc09-c7d6-7473-b339-d0ee44ee51a9",
        "storage_key": "property/6767906449165635/019ecc09-c7d6-7473-b339-d0ee44ee51a9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a sleek vanity with a marble countertop, a toilet, and a shower/tub combo with a neutral-toned shower curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9744814f-3235-4c45-baa5-9bb44dbe0a2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-c4b9-7602-9177-95a50a6f4027.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving.",
        "public_id": "019ecc09-c4b9-7602-9177-95a50a6f4027",
        "storage_key": "property/6767906449165635/019ecc09-c4b9-7602-9177-95a50a6f4027.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring multiple tiers of white wire shelving, perfect for organized storage.",
      "link": "",
      "alt_text": "Empty walk-in closet with white wire shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7cfc5985-b469-4671-a002-eba52eb1c6ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-bfa0-72cd-8443-9f658eec14b5.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, dresser, nightstand, and a ceiling fan.",
        "public_id": "019ecc09-bfa0-72cd-8443-9f658eec14b5",
        "storage_key": "property/6767906449165635/019ecc09-bfa0-72cd-8443-9f658eec14b5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy and stylish bedroom featuring a comfortable queen-size bed, ample storage with a dresser and nightstand, and a ceiling fan for optimal comfort.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, dresser, nightstand, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cae8b417-d3ca-41ef-a72d-73ddf572e923",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-b95d-7494-9e65-871504e7d9eb.webp",
      "image_media": {
        "alt_text": "Kitchen island with double sink, leading into living area with fireplace and dining table.",
        "public_id": "019ecc09-b95d-7494-9e65-871504e7d9eb",
        "storage_key": "property/6767906449165635/019ecc09-b95d-7494-9e65-871504e7d9eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and modern kitchen, perfect for entertaining, that flows seamlessly into the living and dining areas. Features a large island, fireplace, and ample natural light.",
      "link": "",
      "alt_text": "Kitchen island with double sink, leading into living area with fireplace and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_481d580c-5e19-456c-9a9f-3b2219cbdc15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-a8f1-735a-b3d4-6498dcfd5dbb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets.",
        "public_id": "019ecc09-a8f1-735a-b3d4-6498dcfd5dbb",
        "storage_key": "property/6767906449165635/019ecc09-a8f1-735a-b3d4-6498dcfd5dbb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring a full suite of stainless steel appliances, spacious granite countertops, and ample cabinet storage for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_833c6145-9129-454c-81d0-955dc605114a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-ac06-713b-bb57-8a21a2807ff2.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, free weights, and a bench.",
        "public_id": "019ecc09-ac06-713b-bb57-8a21a2807ff2",
        "storage_key": "property/6767906449165635/019ecc09-ac06-713b-bb57-8a21a2807ff2.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with modern cardio machines and a comprehensive set of free weights.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, free weights, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44336269-7741-40b3-a600-4e4b66cff91a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-95c3-7239-b641-441c39d4e1e9.webp",
      "image_media": {
        "alt_text": "Fitness center with dumbbell racks, medicine balls, and a workout bench.",
        "public_id": "019ecc09-95c3-7239-b641-441c39d4e1e9",
        "storage_key": "property/6767906449165635/019ecc09-95c3-7239-b641-441c39d4e1e9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a wide range of weights, medicine balls, and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with dumbbell racks, medicine balls, and a workout bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6db79afa-fd68-4bc0-a201-94d6dd77402c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-96f5-73f6-9159-d73cd3fc75f3.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, and recumbent bike.",
        "public_id": "019ecc09-96f5-73f6-9159-d73cd3fc75f3",
        "storage_key": "property/6767906449165635/019ecc09-96f5-73f6-9159-d73cd3fc75f3.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment and weight machines for a comprehensive workout.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, and recumbent bike.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1569f64-d6d1-4d7e-aaa9-f0db94e80568",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-96f6-7508-8925-4e4ef7fec7e0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, microwave, and oven, light wood cabinets, and a granite countertop.",
        "public_id": "019ecc09-96f6-7508-8925-4e4ef7fec7e0",
        "storage_key": "property/6767906449165635/019ecc09-96f6-7508-8925-4e4ef7fec7e0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring ample cabinet space, modern appliances, and a breakfast bar with comfortable seating, perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel refrigerator, microwave, and oven, light wood cabinets, and a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_223a6a04-7189-47c1-8bfb-48ac8f86f9b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-955f-72cc-b404-cc4a5c9bd1bc.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with treadmills, ellipticals, and a recumbent bike, featuring a large mirrored wall and natural light.",
        "public_id": "019ecc09-955f-72cc-b404-cc4a5c9bd1bc",
        "storage_key": "property/6767906449165635/019ecc09-955f-72cc-b404-cc4a5c9bd1bc.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring modern cardio machines and ample space for your workout routine.",
      "link": "",
      "alt_text": "State-of-the-art fitness center with treadmills, ellipticals, and a recumbent bike, featuring a large mirrored wall and natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c4520df4-5038-4701-9a57-d3225e38e5e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-9aa0-734b-8c32-502b0aeac73e.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment complex gym with treadmills, ellipticals, weight rack, and medicine balls.",
        "public_id": "019ecc09-9aa0-734b-8c32-502b0aeac73e",
        "storage_key": "property/6767906449165635/019ecc09-9aa0-734b-8c32-502b0aeac73e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, and a full range of free weights and exercise accessories.",
      "link": "",
      "alt_text": "Interior of a modern apartment complex gym with treadmills, ellipticals, weight rack, and medicine balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97f3943e-a240-4d24-93be-26e7cefbdacd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-94c1-711c-9d9f-4327677a651b.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, white sofa, and dining table.",
        "public_id": "019ecc09-94c1-711c-9d9f-4327677a651b",
        "storage_key": "property/6767906449165635/019ecc09-94c1-711c-9d9f-4327677a651b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a modern fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Living room with fireplace, white sofa, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e206bd6-2c42-4daf-b584-fb3ba52d288a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-4c18-7078-ab4b-ce3811167144.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a large sectional sofa, a modern chandelier, and a stone fireplace.",
        "public_id": "019ecc09-4c18-7078-ab4b-ce3811167144",
        "storage_key": "property/6767906449165635/019ecc09-4c18-7078-ab4b-ce3811167144.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating, a cozy fireplace, and ample space for socializing.",
      "link": "",
      "alt_text": "Spacious community lounge with a large sectional sofa, a modern chandelier, and a stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_71a7a66b-0d8d-4262-8713-7c8672131cb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-4d89-767f-8a24-eb671ad50ad8.webp",
      "image_media": {
        "alt_text": "Luxurious clubhouse living room with a large stone fireplace, sectional sofa, and elegant chandelier.",
        "public_id": "019ecc09-4d89-767f-8a24-eb671ad50ad8",
        "storage_key": "property/6767906449165635/019ecc09-4d89-767f-8a24-eb671ad50ad8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed clubhouse, featuring a grand stone fireplace, comfortable seating, and a sophisticated ambiance for residents.",
      "link": "",
      "alt_text": "Luxurious clubhouse living room with a large stone fireplace, sectional sofa, and elegant chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8deee732-4b2f-4f9f-8afd-766705d567ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-4bb6-75cf-907e-b597017b5ae0.webp",
      "image_media": {
        "alt_text": "Spacious seating area with a modern fireplace and large sectional sofa in a property's common area.",
        "public_id": "019ecc09-4bb6-75cf-907e-b597017b5ae0",
        "storage_key": "property/6767906449165635/019ecc09-4bb6-75cf-907e-b597017b5ae0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting common area, featuring a cozy fireplace and comfortable seating, perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Spacious seating area with a modern fireplace and large sectional sofa in a property's common area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7693f6c7-724b-4f7e-a21e-759be5a052db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-4adb-74e9-80a9-719062535193.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and kitchenette area.",
        "public_id": "019ecc09-4adb-74e9-80a9-719062535193",
        "storage_key": "property/6767906449165635/019ecc09-4adb-74e9-80a9-719062535193.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected and productive in our business center, equipped with computers and high-speed internet. Enjoy complimentary coffee and snacks in the adjacent kitchenette.",
      "link": "",
      "alt_text": "Business center with computers, printer, and kitchenette area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93bd229f-4e35-49e5-a4ff-491b92daef52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-4b64-7689-9586-371aa4f878b0.webp",
      "image_media": {
        "alt_text": "Modern community lounge with fireplace, TV, and seating area.",
        "public_id": "019ecc09-4b64-7689-9586-371aa4f878b0",
        "storage_key": "property/6767906449165635/019ecc09-4b64-7689-9586-371aa4f878b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy fireplace, comfortable seating, and a convenient work area.",
      "link": "",
      "alt_text": "Modern community lounge with fireplace, TV, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd900a97-e80b-4bab-b04d-aa96a7668928",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-d3ff-7728-99d2-4c4ac830b5c7.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019ecc08-d3ff-7728-99d2-4c4ac830b5c7",
        "storage_key": "property/6767906449165635/019ecc08-d3ff-7728-99d2-4c4ac830b5c7.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating. Enjoy the perfect outdoor oasis.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6f0d6364-60cd-475b-bbce-b56f6e56f21b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-de48-70bd-9abd-35db4eb9930f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and outdoor lounge areas with apartment buildings in the background at sunset.",
        "public_id": "019ecc08-de48-70bd-9abd-35db4eb9930f",
        "storage_key": "property/6767906449165635/019ecc08-de48-70bd-9abd-35db4eb9930f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and outdoor lounge areas, perfect for relaxing or entertaining, set against a beautiful sunset backdrop.",
      "link": "",
      "alt_text": "Resort-style swimming pool and outdoor lounge areas with apartment buildings in the background at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4dc0313b-dd7b-40a6-a504-12a67be7fa34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-d53f-7683-b3a0-51ee26f70299.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019ecc08-d53f-7683-b3a0-51ee26f70299",
        "storage_key": "property/6767906449165635/019ecc08-d53f-7683-b3a0-51ee26f70299.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. An ideal spot for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e316f81-0110-47af-ada6-680699fd4168",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-ce85-73cb-87db-8e1c3f599c23.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019ecc08-ce85-73cb-87db-8e1c3f599c23",
        "storage_key": "property/6767906449165635/019ecc08-ce85-73cb-87db-8e1c3f599c23.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. A perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c7da177-4bad-4916-b1b1-e6180e3c236f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-d539-7529-b649-f03d41f23d7c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019ecc08-d539-7529-b649-f03d41f23d7c",
        "storage_key": "property/6767906449165635/019ecc08-d539-7529-b649-f03d41f23d7c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c8ddbbb-2ab7-4ab3-a1f8-a8197ce0db1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-d122-74fd-a406-76c8e32636d8.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with lounge chairs and a table under a pergola, with apartment buildings in the background.",
        "public_id": "019ecc08-d122-74fd-a406-76c8e32636d8",
        "storage_key": "property/6767906449165635/019ecc08-d122-74fd-a406-76c8e32636d8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our community's shaded outdoor seating area, complete with comfortable lounge chairs and a dining table.",
      "link": "",
      "alt_text": "Outdoor seating area with lounge chairs and a table under a pergola, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec98ab7b-9093-468f-8c48-474c70d7d95d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-b6b2-76fa-8d9d-633dd34c301e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019ecc08-b6b2-76fa-8d9d-633dd34c301e",
        "storage_key": "property/6767906449165635/019ecc08-b6b2-76fa-8d9d-633dd34c301e.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23710332-1f5d-4a0c-bad1-506e52b76d94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-a70c-77c7-a11b-93f1c74fff39.webp",
      "image_media": {
        "alt_text": "The Reserve apartment complex monument sign with American flag.",
        "public_id": "019ecc08-a70c-77c7-a11b-93f1c74fff39",
        "storage_key": "property/6767906449165635/019ecc08-a70c-77c7-a11b-93f1c74fff39.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to The Reserve, where luxury living and convenience await. This monument sign features the property's logo and an American flag, set against a backdrop of lush landscaping.",
      "link": "",
      "alt_text": "The Reserve apartment complex monument sign with American flag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a1ed4ba6-ac42-4cb9-bbcd-c02db866cec8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-aaec-70fc-872c-78213ab356e4.webp",
      "image_media": {
        "alt_text": "The Reserve apartment buildings and entrance.",
        "public_id": "019ecc08-aaec-70fc-872c-78213ab356e4",
        "storage_key": "property/6767906449165635/019ecc08-aaec-70fc-872c-78213ab356e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the apartment buildings and the community entrance at The Reserve.",
      "link": "",
      "alt_text": "The Reserve apartment buildings and entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9dfe4317-dabc-4630-8263-6a79ddf72073",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-a124-709d-8e4c-4bdda925a99b.webp",
      "image_media": {
        "alt_text": "The Reserve at Elm Urban Apartments building entrance with signage.",
        "public_id": "019ecc08-a124-709d-8e4c-4bdda925a99b",
        "storage_key": "property/6767906449165635/019ecc08-a124-709d-8e4c-4bdda925a99b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Reserve at Elm Urban Apartments. Discover modern living in a vibrant community.",
      "link": "",
      "alt_text": "The Reserve at Elm Urban Apartments building entrance with signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39161c12-6fa0-48e9-a992-cdea0643b4ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-b0c8-7345-9406-af2fd337928b.webp",
      "image_media": {
        "alt_text": "The Reserve apartment complex signage and entrance gate.",
        "public_id": "019ecc08-b0c8-7345-9406-af2fd337928b",
        "storage_key": "property/6767906449165635/019ecc08-b0c8-7345-9406-af2fd337928b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Reserve, featuring a prominent monument sign at the entrance, flanked by manicured landscaping and an inviting gate.",
      "link": "",
      "alt_text": "The Reserve apartment complex signage and entrance gate.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54d33c07-0317-4f06-8645-698acbb08589",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-a4f4-7268-b543-3a780570382a.webp",
      "image_media": {
        "alt_text": "Exterior of the Reserve apartment complex with a brick building and parking lot.",
        "public_id": "019ecc08-a4f4-7268-b543-3a780570382a",
        "storage_key": "property/6767906449165635/019ecc08-a4f4-7268-b543-3a780570382a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Reserve, a premier apartment community featuring modern amenities and comfortable living spaces.",
      "link": "",
      "alt_text": "Exterior of the Reserve apartment complex with a brick building and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a7a8ad8-c194-46af-98ca-e6a6ae0cc519",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-9c88-72eb-8b4c-dae5bf46c813.webp",
      "image_media": {
        "alt_text": "The Reserve apartment building exterior with signage.",
        "public_id": "019ecc08-9c88-72eb-8b4c-dae5bf46c813",
        "storage_key": "property/6767906449165635/019ecc08-9c88-72eb-8b4c-dae5bf46c813.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of The Reserve apartment complex featuring a central building with prominent signage and surrounding trees.",
      "link": "",
      "alt_text": "The Reserve apartment building exterior with signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61c7bad1-926c-42a9-a804-39cc5ab5b50d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-7a31-77bc-bd4b-a1dc2dc4d09c.webp",
      "image_media": {
        "alt_text": "Apartment community dog park with agility equipment and seating.",
        "public_id": "019ecc08-7a31-77bc-bd4b-a1dc2dc4d09c",
        "storage_key": "property/6767906449165635/019ecc08-7a31-77bc-bd4b-a1dc2dc4d09c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize in a safe and secure environment.",
      "link": "",
      "alt_text": "Apartment community dog park with agility equipment and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4271e487-5424-44d8-a8f9-05393cbdd809",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-79b7-72fd-9845-7e9453e576da.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and seating area",
        "public_id": "019ecc08-79b7-72fd-9845-7e9453e576da",
        "storage_key": "property/6767906449165635/019ecc08-79b7-72fd-9845-7e9453e576da.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment and a relaxing seating area for pet owners.",
      "link": "",
      "alt_text": "Dog park with agility equipment and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_261d5bf7-1e3c-4e67-812a-fd74f5352c33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-6b55-768e-bb20-ce6f2b86be23.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with attached garages under a clear blue sky.",
        "public_id": "019ecc08-6b55-768e-bb20-ce6f2b86be23",
        "storage_key": "property/6767906449165635/019ecc08-6b55-768e-bb20-ce6f2b86be23.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a multi-unit apartment building featuring attached garages. The building has a modern design with brick accents and a neutral-colored facade, set against a backdrop of a bright blue sky with scattered clouds.",
      "link": "",
      "alt_text": "Exterior view of apartment building with attached garages under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8fcdde7a-1aa1-48c7-8fdb-ab42916d9901",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-6b56-75c9-97db-6ea3fe9c4dd5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by lush greenery and apartment buildings.",
        "public_id": "019ecc08-6b56-75c9-97db-6ea3fe9c4dd5",
        "storage_key": "property/6767906449165635/019ecc08-6b56-75c9-97db-6ea3fe9c4dd5.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by lush greenery and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b44fdc4d-3467-49ab-b0e2-9ab2645d2de7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-7b95-73ec-bad1-4ee4091706e9.webp",
      "image_media": {
        "alt_text": "Apartment buildings surround a grassy courtyard with a picnic table and BBQ grill.",
        "public_id": "019ecc08-7b95-73ec-bad1-4ee4091706e9",
        "storage_key": "property/6767906449165635/019ecc08-7b95-73ec-bad1-4ee4091706e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in the communal courtyard, complete with a picnic table and BBQ grill, nestled between modern apartment buildings.",
      "link": "",
      "alt_text": "Apartment buildings surround a grassy courtyard with a picnic table and BBQ grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e627be3f-c544-4ca4-9c6a-82a93599d28a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-7a69-74ca-8a21-00de4e0a388a.webp",
      "image_media": {
        "alt_text": "Sidewalks winding through a courtyard with manicured lawns and trees.",
        "public_id": "019ecc08-7a69-74ca-8a21-00de4e0a388a",
        "storage_key": "property/6767906449165635/019ecc08-7a69-74ca-8a21-00de4e0a388a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stroll through the beautifully landscaped courtyards, offering a peaceful escape with lush green lawns and mature trees.",
      "link": "",
      "alt_text": "Sidewalks winding through a courtyard with manicured lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dbd40d13-9166-4177-8854-8ed5dc28f5ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-5087-72ec-941d-08f8b74f2970.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a well-maintained lawn and pathway.",
        "public_id": "019ecc08-5087-72ec-941d-08f8b74f2970",
        "storage_key": "property/6767906449165635/019ecc08-5087-72ec-941d-08f8b74f2970.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautiful grounds and outdoor amenities of our apartment community, featuring lush green spaces and a relaxing atmosphere.",
      "link": "",
      "alt_text": "Apartment buildings with a well-maintained lawn and pathway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_129ca8d2-9fb9-4934-bb39-933b65973410",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-5096-70ee-9eba-ad0dc2f42cbf.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and built-in grills.",
        "public_id": "019ecc08-5096-70ee-9eba-ad0dc2f42cbf",
        "storage_key": "property/6767906449165635/019ecc08-5096-70ee-9eba-ad0dc2f42cbf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our outdoor grilling stations, complete with picnic tables and built-in grills for your convenience.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and built-in grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0ad06568-16f5-46b1-a9d8-fa9574ba79f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-5744-764c-bf23-2ca272122723.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building entrance with landscaping and a spiral topiary.",
        "public_id": "019ecc08-5744-764c-bf23-2ca272122723",
        "storage_key": "property/6767906449165635/019ecc08-5744-764c-bf23-2ca272122723.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "The welcoming exterior of the apartment complex, featuring a well-maintained entrance with lush landscaping and an attractive spiral topiary, sets a pleasant tone for residents and visitors.",
      "link": "",
      "alt_text": "Exterior of apartment building entrance with landscaping and a spiral topiary.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d059af9-e265-4e34-baca-5b26155ec9ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-56de-7637-b2d5-63c36f9ab486.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with manicured landscaping and blue sky.",
        "public_id": "019ecc08-56de-7637-b2d5-63c36f9ab486",
        "storage_key": "property/6767906449165635/019ecc08-56de-7637-b2d5-63c36f9ab486.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming exterior view showcasing the building's architecture, surrounded by lush greenery and a clear blue sky, offering a glimpse of the welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior view of the apartment building with manicured landscaping and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6ff5f2b-7a32-4a46-82fd-6db2600409be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-56cb-7385-a11b-50c71c6d8873.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas, surrounded by apartment buildings and landscaping.",
        "public_id": "019ecc08-56cb-7385-a11b-50c71c6d8873",
        "storage_key": "property/6767906449165635/019ecc08-56cb-7385-a11b-50c71c6d8873.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge seating and shaded areas. A perfect spot for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas, surrounded by apartment buildings and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af71a784-1d5d-404a-b554-70158cb7f777",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-56d7-72de-bbc0-26c01bbb0d10.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and umbrellas.",
        "public_id": "019ecc08-56d7-72de-bbc0-26c01bbb0d10",
        "storage_key": "property/6767906449165635/019ecc08-56d7-72de-bbc0-26c01bbb0d10.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our outdoor grilling stations, perfect for al fresco dining and socializing with friends and family.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4dd4f43d-c2a8-4587-932f-11bd49ec3fd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-3b7a-7056-b0c5-14dc412bb2fd.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables and built-in grills.",
        "public_id": "019ecc08-3b7a-7056-b0c5-14dc412bb2fd",
        "storage_key": "property/6767906449165635/019ecc08-3b7a-7056-b0c5-14dc412bb2fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community's outdoor grilling station, featuring picnic tables and built-in barbecues for resident use.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables and built-in grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9e5e17fe-7519-4bf0-a16f-fcaa6f347c26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-3ab6-7299-ba6a-26e1718e962e.webp",
      "image_media": {
        "alt_text": "Exterior courtyard with swimming pool and lounge area",
        "public_id": "019ecc08-3ab6-7299-ba6a-26e1718e962e",
        "storage_key": "property/6767906449165635/019ecc08-3ab6-7299-ba6a-26e1718e962e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained courtyard featuring a sparkling swimming pool, comfortable lounge areas, outdoor grills, and lush landscaping.",
      "link": "",
      "alt_text": "Exterior courtyard with swimming pool and lounge area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_cc1da8c5-d926-464c-8c6b-ed08938d9289",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-91d8-757c-82ac-5e9e36226e82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-91d8-757c-82ac-5e9e36226e82",
        "storage_key": "property/6767906449165635/019d2709-91d8-757c-82ac-5e9e36226e82.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c236-7663-b65f-c55a778a297c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c236-7663-b65f-c55a778a297c",
        "storage_key": "property/6767906449165635/019d2709-c236-7663-b65f-c55a778a297c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_df6efe87-d84a-45dc-aafd-a4e6bdc26de2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "8204 S Olympia Ave W, Tulsa, OK 74132, USA",
      "poi_short_description": "Chain steakhouse offering hand-cut steaks, ribs, and other American fare in a laid-back setting.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and catfish, and the rolls with cinnamon butter are a must-try. They highlight the reasonable prices and consistent quality of the food. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-92b3-7279-822e-0629c4bc5384.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-92b3-7279-822e-0629c4bc5384",
        "storage_key": "property/6767906449165635/019d2709-92b3-7279-822e-0629c4bc5384.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-s-olympia-ave?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10653753003214397634&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0450715",
      "poi_longitude": "-96.005574",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-445-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c236-7663-b65f-c55a778a297c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c236-7663-b65f-c55a778a297c",
        "storage_key": "property/6767906449165635/019d2709-c236-7663-b65f-c55a778a297c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWgROD6UtocRwmBYEem72ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_0ec305ab-c0c1-4195-9d05-958c69287d30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Neighborhood JAM",
      "poi_type": "Restaurants",
      "poi_address": "4830 E 61st St #300, Tulsa, OK 74136, USA",
      "poi_short_description": "Relaxed restaurant at the Shops at Warren Place attracting diners for breakfast, brunch, and lunch.",
      "poi_long_description": "People say this restaurant serves delicious breakfast tacos, pancakes, and other brunch options, including gluten-free choices. They highlight the generous portions, reasonable prices, and the fun, lively atmosphere, especially on the patio. They also like the friendly, attentive, and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-91ec-7774-b096-7da2c932c4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-91ec-7774-b096-7da2c932c4c6",
        "storage_key": "property/6767906449165635/019d2709-91ec-7774-b096-7da2c932c4c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thatsmyjamok.com/locations/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10095226965287487523&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neighborhood-jam",
      "poi_latitude": "36.0743128",
      "poi_longitude": "-95.922983",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-508-7744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c236-7663-b65f-c55a778a297c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c236-7663-b65f-c55a778a297c",
        "storage_key": "property/6767906449165635/019d2709-c236-7663-b65f-c55a778a297c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK2Z2CQ6TtocRI8jnKHBzGYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_44d81a1b-5a37-4e6a-8430-54fc40544e6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Tulsa Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Buffet, pizza and game chain featuring bumper cars and laser-tag attractions.",
      "poi_long_description": "People say this pizza restaurant offers a buffet with a wide variety of options, including pizza, hot dogs, fried chicken, and desserts, as well as rides, games, and attractions like go-karts and laser tag. They also highlight the fun experience, the friendly staff, and the good value for the price.\n\nOther reviews mention the games can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-919e-717a-9933-d8bdf4003435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-919e-717a-9933-d8bdf4003435",
        "storage_key": "property/6767906449165635/019d2709-919e-717a-9933-d8bdf4003435.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-incredible-pizza-company",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c236-7663-b65f-c55a778a297c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c236-7663-b65f-c55a778a297c",
        "storage_key": "property/6767906449165635/019d2709-c236-7663-b65f-c55a778a297c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d44c885e-443d-4f19-8cbf-b6ddc06a03e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-95d5-71ea-8452-b004f301877a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-95d5-71ea-8452-b004f301877a",
        "storage_key": "property/6767906449165635/019d2709-95d5-71ea-8452-b004f301877a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c217-7799-a73a-876093b7e61e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c217-7799-a73a-876093b7e61e",
        "storage_key": "property/6767906449165635/019d2709-c217-7799-a73a-876093b7e61e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_f129c94a-5ccd-4594-aae8-a451329ebd6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-96f2-767c-ac79-dd847563260c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-96f2-767c-ac79-dd847563260c",
        "storage_key": "property/6767906449165635/019d2709-96f2-767c-ac79-dd847563260c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c217-7799-a73a-876093b7e61e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c217-7799-a73a-876093b7e61e",
        "storage_key": "property/6767906449165635/019d2709-c217-7799-a73a-876093b7e61e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_47571c3e-d29b-4a87-a393-8f3582d10666",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3702 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Spacious store and chain supermarket known for its affordable prices and wide variety of foods from around the world, including organic and vegan options.",
      "poi_long_description": "People say this grocery store offers a wide variety of unique items, fresh flowers, and delicious snacks. They highlight the great value, affordable prices, and clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-9788-70ad-a2d1-44722b4fff77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9788-70ad-a2d1-44722b4fff77",
        "storage_key": "property/6767906449165635/019d2709-9788-70ad-a2d1-44722b4fff77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/tulsa/460/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13583892652892204013&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "36.1096067",
      "poi_longitude": "-95.975934",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-712-9768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c212-755e-bc7c-ded7a9514bbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c212-755e-bc7c-ded7a9514bbc",
        "storage_key": "property/6767906449165635/019d2709-c212-755e-bc7c-ded7a9514bbc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TxY2lOTtocR7autsmWug7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1ae49498-4fb7-4459-a557-bbd24b7f1256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Tulsa Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Outdoor mall featuring Big Box stores alongside multiple restaurants and a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and convenient stores. They highlight the convenient parking, easy access, and clean facilities. They also like the variety of businesses, including an emergency hospital and EV charging stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-9894-7283-b295-925a56cffa08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9894-7283-b295-925a56cffa08",
        "storage_key": "property/6767906449165635/019d2709-9894-7283-b295-925a56cffa08.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://www.shoptulsahills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185409236621719808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-hills-shopping-center",
      "poi_latitude": "36.0563227",
      "poi_longitude": "-96.0033215",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-979-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c217-7799-a73a-876093b7e61e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c217-7799-a73a-876093b7e61e",
        "storage_key": "property/6767906449165635/019d2709-c217-7799-a73a-876093b7e61e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5R7A_GeUtocRAPl5hIaPFTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_70b2884c-97d5-48b8-9108-8b7a6202295c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-9b67-73df-95f9-33da3ca3af06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9b67-73df-95f9-33da3ca3af06",
        "storage_key": "property/6767906449165635/019d2709-9b67-73df-95f9-33da3ca3af06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c212-755e-bc7c-ded7a9514bbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c212-755e-bc7c-ded7a9514bbc",
        "storage_key": "property/6767906449165635/019d2709-c212-755e-bc7c-ded7a9514bbc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_440f132e-44fd-410c-9086-26f5e6fd5abb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-9be5-7588-9a3e-7b2db77f4798.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9be5-7588-9a3e-7b2db77f4798",
        "storage_key": "property/6767906449165635/019d2709-9be5-7588-9a3e-7b2db77f4798.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c344-73bb-9d8b-18f588d9ccdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c344-73bb-9d8b-18f588d9ccdf",
        "storage_key": "property/6767906449165635/019d2709-c344-73bb-9d8b-18f588d9ccdf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5d6d8514-b158-4469-8d34-d3b03a20470b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-9cb6-72a8-b2ee-6f84dc1cb397.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9cb6-72a8-b2ee-6f84dc1cb397",
        "storage_key": "property/6767906449165635/019d2709-9cb6-72a8-b2ee-6f84dc1cb397.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c344-73bb-9d8b-18f588d9ccdf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c344-73bb-9d8b-18f588d9ccdf",
        "storage_key": "property/6767906449165635/019d2709-c344-73bb-9d8b-18f588d9ccdf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e0162d9c-65c4-4702-8c8a-792716e7bc5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-9e0c-746b-a796-3ee91d686d69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9e0c-746b-a796-3ee91d686d69",
        "storage_key": "property/6767906449165635/019d2709-9e0c-746b-a796-3ee91d686d69.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_2a5e9bee-b1e1-42e1-862b-171abbede659",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a0c8-7169-b8ac-eba688190678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a0c8-7169-b8ac-eba688190678",
        "storage_key": "property/6767906449165635/019d2709-a0c8-7169-b8ac-eba688190678.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_fa96ec7d-e39b-4125-94ab-a71e17d09382",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a084-77f5-85fd-88bd2bb26aca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a084-77f5-85fd-88bd2bb26aca",
        "storage_key": "property/6767906449165635/019d2709-a084-77f5-85fd-88bd2bb26aca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_934c4f45-0367-4a2d-b4c8-383e65e934c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Glenpool Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Glenpool, OK 74033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a115-757f-940f-bf45b981787e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a115-757f-940f-bf45b981787e",
        "storage_key": "property/6767906449165635/019d2709-a115-757f-940f-bf45b981787e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2515",
      "poi_directions_map_url": "https://maps.google.com/?cid=4358265321363034112&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glenpool-football-stadium",
      "poi_latitude": "35.9456924",
      "poi_longitude": "-96.004093",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-322-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5f9-704e-9ec3-e4901532d110.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5f9-704e-9ec3-e4901532d110",
        "storage_key": "property/6767906449165635/019d2709-c5f9-704e-9ec3-e4901532d110.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVks912XtocRAFC__Derezw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f0afab10-67ce-457b-ac4f-6c118eba7fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "The Sherwin Miller Museum of Jewish Art",
      "poi_type": "Entertainment",
      "poi_address": "2021 E 71st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Museum with exhibits on Jewish art, history, and culture, plus a Holocaust display, and a Purim mask contest.",
      "poi_long_description": "Museum with a gallery on art & artifacts related to Jewish history plus a Holocaust exhibit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a3cc-72eb-a1af-d6e6731fbaf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a3cc-72eb-a1af-d6e6731fbaf8",
        "storage_key": "property/6767906449165635/019d2709-a3cc-72eb-a1af-d6e6731fbaf8.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.jewishmuseumtulsa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10776410231160628210&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-sherwin-miller-museum-of-jewish-art",
      "poi_latitude": "36.0620308",
      "poi_longitude": "-95.9635391",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-492-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c6b1-73a8-a1b4-95b4dde853bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c6b1-73a8-a1b4-95b4dde853bd",
        "storage_key": "property/6767906449165635/019d2709-c6b1-73a8-a1b4-95b4dde853bd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJdUedQpiTtocR8uM2ZgKAjZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fde0d11d-9f1f-45f8-90e7-1578fa6ab1fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a563-721e-ba39-6fa3327b55e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a563-721e-ba39-6fa3327b55e4",
        "storage_key": "property/6767906449165635/019d2709-a563-721e-ba39-6fa3327b55e4.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_15853f0e-2fb7-4dbb-8a81-e2086035f939",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a6a9-744b-8c70-2e6fc0994c06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a6a9-744b-8c70-2e6fc0994c06",
        "storage_key": "property/6767906449165635/019d2709-a6a9-744b-8c70-2e6fc0994c06.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3bc2cb19-60d5-4f72-84d7-e2552eb337d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1331 E 71st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Chain gym offering a variety of fitness equipment, with tanning, and massage options, plus 24/7 access.",
      "poi_long_description": "People say this gym offers a multitude of machines and equipment, and is clean and well-maintained. They highlight the friendly and helpful staff, and the good atmosphere. They also like the convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a5c1-7488-b552-731716e12c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a5c1-7488-b552-731716e12c4e",
        "storage_key": "property/6767906449165635/019d2709-a5c1-7488-b552-731716e12c4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tulsa-riverside-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13693593335410364020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0614737",
      "poi_longitude": "-95.9748504",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 539-525-9151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDx_GDIWTtocRdI7KN5ZqCb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_90e88255-8b10-4b90-a55d-ce09f9a4b824",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Oklahoma Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 West 78th Street South, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a84c-7109-881f-9c12cdc4ba17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a84c-7109-881f-9c12cdc4ba17",
        "storage_key": "property/6767906449165635/019d2709-a84c-7109-881f-9c12cdc4ba17.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://okvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093478136724344104&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-veterinary-specialists",
      "poi_latitude": "36.0519175",
      "poi_longitude": "-96.0079484",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-299-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocRKE2sAmGrr0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_9243dcbc-cec8-4b7e-860d-5904af9f3874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "4818 E 80th St Ste A, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, fitness classes, and amenities, including tanning, massage beds, and a sauna. They highlight the clean facilities, friendly staff, and welcoming atmosphere, with people from all walks of life enjoying their workouts. They also like the affordable prices and convenient 24-hour access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a99e-75d6-b1fe-1b0ee024fa59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a99e-75d6-b1fe-1b0ee024fa59",
        "storage_key": "property/6767906449165635/019d2709-a99e-75d6-b1fe-1b0ee024fa59.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://10gym.com/south-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406416433432823692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.047648",
      "poi_longitude": "-95.9239656",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-494-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-ITWKKTtocRjAdtGP9OZSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ac581f93-de42-4dfb-8e79-4f20352224c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "8722 E 71st St Suite 872, Tulsa, OK 74133, USA",
      "poi_short_description": "Chains such as this one sell cosmetics, fragrances and makeup in stores and online, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-a9f8-75a2-9fbc-832585620772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a9f8-75a2-9fbc-832585620772",
        "storage_key": "property/6767906449165635/019d2709-a9f8-75a2-9fbc-832585620772.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-1113",
      "poi_directions_map_url": "https://maps.google.com/?cid=9163598623872888103&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.059026",
      "poi_longitude": "-95.8790444",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-250-9053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUwgJEyMtocRJ60zyGWkK38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_7c9fbfbf-f0a0-400b-9fb1-ddd2f21b7431",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Health Zone at Saint Francis",
      "poi_type": "Health and Wellness",
      "poi_address": "5353 E 68th St, Tulsa, OK 74136, USA",
      "poi_short_description": "Clean fitness center with an exercise pool and friendly staff.",
      "poi_long_description": "People say this fitness center offers a variety of classes, exercise equipment, and pools, including a warm water group exercise pool and a cooler lap swimming pool. They highlight the clean facilities, with amenities such as towels, shampoo, conditioner, body wash, and lotions, and the convenient snack bar. They also like the friendly and helpful staff, and the professional and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-aaa0-74bf-96e0-05f3f2f8a1c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aaa0-74bf-96e0-05f3f2f8a1c4",
        "storage_key": "property/6767906449165635/019d2709-aaa0-74bf-96e0-05f3f2f8a1c4.webp",
        "width": 350,
        "height": 350
      },
      "poi_business_url": "https://saintfrancis.com/health-zone/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9278000897024696176&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "health-zone-at-saint-francis",
      "poi_latitude": "36.0652247",
      "poi_longitude": "-95.9166471",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-494-1671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5ZrRWaStocRcJ_prKgUwoA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_5f948217-c6fe-4f9b-9839-d0882fa1b15b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Woodland West Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9360 S Union Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-acee-71ab-b301-f18e6db2d980.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-acee-71ab-b301-f18e6db2d980",
        "storage_key": "property/6767906449165635/019d2709-acee-71ab-b301-f18e6db2d980.webp",
        "width": 956,
        "height": 960
      },
      "poi_business_url": "http://woodlandwestanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13255369589477481966&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-west-animal-hospital",
      "poi_latitude": "36.0280453",
      "poi_longitude": "-96.0128987",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-1208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocR7h1SY2mI9Lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_666f42d6-65ab-44dd-8dce-8fd3ebea7075",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - South Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "10121 S Sheridan Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Modern gym with friendly staff offering classes on yoga, CrossFit and spinning, plus a spa center.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, fun classes, and a full-service spa with massage and facial services. They highlight the clean facilities, well-maintained equipment, and the availability of amenities like a sauna, steam room, and smoothie bar. They also like the friendly and helpful staff, and the welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-ae19-75bf-9519-5d7fa5391485.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ae19-75bf-9519-5d7fa5391485",
        "storage_key": "property/6767906449165635/019d2709-ae19-75bf-9519-5d7fa5391485.webp",
        "width": 841,
        "height": 473
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/south-tulsa.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7877120599941720959&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "genesis-health-clubs---south-tulsa",
      "poi_latitude": "36.0162172",
      "poi_longitude": "-95.9033684",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-299-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XBN6-ORtocRfytwbHMnUW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f57856c7-3979-4c30-9e71-48d54694e13b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-af56-7318-a5f6-e283c966afc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-af56-7318-a5f6-e283c966afc9",
        "storage_key": "property/6767906449165635/019d2709-af56-7318-a5f6-e283c966afc9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c94b-710b-9824-bbbd3b3365cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c94b-710b-9824-bbbd3b3365cf",
        "storage_key": "property/6767906449165635/019d2709-c94b-710b-9824-bbbd3b3365cf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_85ca815c-77ff-4756-9357-32b9a6bdf936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Saint Francis Children's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-afa3-7336-b1aa-d49eb786f92a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-afa3-7336-b1aa-d49eb786f92a",
        "storage_key": "property/6767906449165635/019d2709-afa3-7336-b1aa-d49eb786f92a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-children-s-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=1661235334016537986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-childrens-hospital",
      "poi_latitude": "36.0735538",
      "poi_longitude": "-95.918465",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-502-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c94b-710b-9824-bbbd3b3365cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c94b-710b-9824-bbbd3b3365cf",
        "storage_key": "property/6767906449165635/019d2709-c94b-710b-9824-bbbd3b3365cf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTCYDmCStocRghViFLzkDRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_575b4a91-137f-4cff-944b-1ae657b3f4da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-b1b8-737f-a336-c4d22722ed75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b1b8-737f-a336-c4d22722ed75",
        "storage_key": "property/6767906449165635/019d2709-b1b8-737f-a336-c4d22722ed75.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c9bc-744a-8686-e6538439da86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9bc-744a-8686-e6538439da86",
        "storage_key": "property/6767906449165635/019d2709-c9bc-744a-8686-e6538439da86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bb37ebb3-b74e-49b7-b4ea-78e2a4c0d9d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-b377-773f-9cf4-94fd35bdb859.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b377-773f-9cf4-94fd35bdb859",
        "storage_key": "property/6767906449165635/019d2709-b377-773f-9cf4-94fd35bdb859.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c9bc-744a-8686-e6538439da86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9bc-744a-8686-e6538439da86",
        "storage_key": "property/6767906449165635/019d2709-c9bc-744a-8686-e6538439da86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_410f2bfb-b776-4a13-bb47-e603783c368c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Turkey Mountain",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6800 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Hilly, forested park featuring jogging, biking & horseback riding trails, plus restrooms.",
      "poi_long_description": "People say this park offers well-maintained trails suitable for hiking, biking, and running, with beautiful views of the city skyline and Arkansas River. They highlight the peaceful and refreshing atmosphere, perfect for connecting with nature and enjoying outdoor activities. They also like the new trail additions and upgrades, and the friendly community of fellow hikers and bikers. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-b4f6-73d8-95c8-0ea98acec4ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b4f6-73d8-95c8-0ea98acec4ef",
        "storage_key": "property/6767906449165635/019d2709-b4f6-73d8-95c8-0ea98acec4ef.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.riverparks.org/experience/turkey-mountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=1129856788357496640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "turkey-mountain",
      "poi_latitude": "36.0648571",
      "poi_longitude": "-95.9934169",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-596-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c9bc-744a-8686-e6538439da86.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c9bc-744a-8686-e6538439da86",
        "storage_key": "property/6767906449165635/019d2709-c9bc-744a-8686-e6538439da86.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWFdbHyUtocRQL8cRcMOrg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bcd92d56-915a-43f7-81a4-02216c498ac7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Page Belcher Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6666 S Union Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Golf course featuring 36 holes, practice facilities & lessons, plus a golf shop & an eatery.",
      "poi_long_description": "Golf course featuring 36 holes, practice facilities & lessons, plus a golf shop & an eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-b536-745e-9b72-fe3cce41874a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b536-745e-9b72-fe3cce41874a",
        "storage_key": "property/6767906449165635/019d2709-b536-745e-9b72-fe3cce41874a.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.tulsagolf.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=36008408697997651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "page-belcher-golf-course",
      "poi_latitude": "36.0662366",
      "poi_longitude": "-96.0153338",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-446-1529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c98d-7125-8c92-a497e0ca3383.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c98d-7125-8c92-a497e0ca3383",
        "storage_key": "property/6767906449165635/019d2709-c98d-7125-8c92-a497e0ca3383.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQOzeFeUtocRUwlf-XTtfwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_09c96ced-6ee2-42ea-89fb-985d58c5b8f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "LaFortune Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5501 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Public golf course with an 18-hole championship course, par-3 course, driving range, and pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-b6a5-73db-a2b6-75989d61ccac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b6a5-73db-a2b6-75989d61ccac",
        "storage_key": "property/6767906449165635/019d2709-b6a5-73db-a2b6-75989d61ccac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lafortuneparkgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2854252431691340547&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park-golf-course",
      "poi_latitude": "36.082485",
      "poi_longitude": "-95.920632",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-496-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c98d-7125-8c92-a497e0ca3383.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c98d-7125-8c92-a497e0ca3383",
        "storage_key": "property/6767906449165635/019d2709-c98d-7125-8c92-a497e0ca3383.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJmUEN-vKStocRA9tB0nZXnCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7924c6be-61ed-433d-bf6b-8f3427a29b7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-b8c5-7403-b6df-8f27b38b0d4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b8c5-7403-b6df-8f27b38b0d4f",
        "storage_key": "property/6767906449165635/019d2709-b8c5-7403-b6df-8f27b38b0d4f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-cac6-71ef-82fe-c818da37f9f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cac6-71ef-82fe-c818da37f9f7",
        "storage_key": "property/6767906449165635/019d2709-cac6-71ef-82fe-c818da37f9f7.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_35a21618-50a8-4f92-b905-84cc6cbe5875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 S Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-b97d-71dd-ae8f-ba54c2b9a887.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b97d-71dd-ae8f-ba54c2b9a887",
        "storage_key": "property/6767906449165635/019d2709-b97d-71dd-ae8f-ba54c2b9a887.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-cac6-71ef-82fe-c818da37f9f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-cac6-71ef-82fe-c818da37f9f7",
        "storage_key": "property/6767906449165635/019d2709-cac6-71ef-82fe-c818da37f9f7.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c8cbb1db-cd22-40a3-ad3b-908b0373c9b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-b9e5-70c3-8b3f-a0ca5f9a3d2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b9e5-70c3-8b3f-a0ca5f9a3d2b",
        "storage_key": "property/6767906449165635/019d2709-b9e5-70c3-8b3f-a0ca5f9a3d2b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d3eb622b-710c-474e-8e79-6ebd3dba9a75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Pepsi Main Truck Gate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5201-5325 S Lawton Ave, Tulsa, OK 74107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-bbd1-71ed-bd2b-90e96bb0103a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bbd1-71ed-bd2b-90e96bb0103a",
        "storage_key": "property/6767906449165635/019d2709-bbd1-71ed-bd2b-90e96bb0103a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4654779687138613676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pepsi-main-truck-gate",
      "poi_latitude": "36.0874451",
      "poi_longitude": "-95.9993929",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQbkIZSUtocRrNmZn3YZmUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7c3afb88-451c-4b94-9800-ce1a90fc6ae7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Casino Cash Trac",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7835 E 106th St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.casinocashtrac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13720834206770318126&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "casino-cash-trac",
      "poi_latitude": "36.0107418",
      "poi_longitude": "-95.8887703",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-794-8255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwaDBRiOtocRLsuS1AMyar4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_09b528c7-3456-45b5-a159-d8c4270fd9f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Jenks Carepoint",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2914 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-bd9b-70ea-947e-693260ef1b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bd9b-70ea-947e-693260ef1b68",
        "storage_key": "property/6767906449165635/019d2709-bd9b-70ea-947e-693260ef1b68.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jenkscarepoint.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8342629785438649781&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jenks-carepoint",
      "poi_latitude": "36.0310709",
      "poi_longitude": "-95.9473523",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-600-2099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpx1KKjCNtocRtf2ptZb5xnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0637dd34-0e46-4b76-827a-8e3acc1cb760",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Phillips 66 Glenpool Terminal",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10600 S Elwood Ave, Jenks, OK 74037, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=692387511301732052&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phillips-66-glenpool-terminal",
      "poi_latitude": "36.0109973",
      "poi_longitude": "-95.9965762",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c5ba-77ca-94aa-a2f9cba7abda",
        "storage_key": "property/6767906449165635/019d2709-c5ba-77ca-94aa-a2f9cba7abda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0sRh2yXtocR1HYO6sXamwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_17d258cf-dbe9-48b3-9452-33613c4a3712",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Jenks West Elementary School",
      "poi_type": "Education",
      "poi_address": "A-E, 900 N Adams St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jenksps.org/o/west-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=9490376297863503861&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-west-elementary-school",
      "poi_latitude": "36.0311422",
      "poi_longitude": "-96.006437",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-4411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4249-74db-82e7-60636e2d10a4",
        "storage_key": "property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCzOyGCKUtocR9d_w8vWWtIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_60065dbe-bf84-4350-be16-5c466bfdb11a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Jenks West Intermediate School",
      "poi_type": "Education",
      "poi_address": "909 N Adams St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jenksps.org/o/west-intermediate",
      "poi_directions_map_url": "https://maps.google.com/?cid=11723754934742872625&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-west-intermediate-school",
      "poi_latitude": "36.0296542",
      "poi_longitude": "-96.0017112",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4249-74db-82e7-60636e2d10a4",
        "storage_key": "property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bj9Px-UtocRMfIUf_8ks6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e30342bd-2f70-4230-8ba2-1a874b4691e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Jenks Middle School",
      "poi_type": "Education",
      "poi_address": "3019 E 101st St S, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jenksps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14101611830866602126&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-middle-school",
      "poi_latitude": "36.0187568",
      "poi_longitude": "-95.9426735",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4249-74db-82e7-60636e2d10a4",
        "storage_key": "property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJscJrOHiRtocRjug_Iz_9ssM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2e7e45bd-66b6-4f36-b725-23311e0c1f89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Jenks High School",
      "poi_type": "Education",
      "poi_address": "205 E B St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-64a7-77bf-801c-02211c328369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-64a7-77bf-801c-02211c328369",
        "storage_key": "property/6767906449165635/019d7913-64a7-77bf-801c-02211c328369.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jenksps.org/o/high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896344340347075511&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-high-school",
      "poi_latitude": "36.0257108",
      "poi_longitude": "-95.9692903",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4249-74db-82e7-60636e2d10a4",
        "storage_key": "property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ5df6ViRtocRt7thUDxP80M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_49a6caf3-1d8e-4cf2-bea1-01bf9d68f931",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill - Tulsa",
      "poi_type": "Restaurants",
      "poi_address": "9916 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "Diners say this American restaurant serves up delicious rotisserie chicken, steak, and ribs, with many raving about the cornbread and coleslaw. They also highlight the friendly and attentive service, as well as the pleasant atmosphere with a great river view, especially on the patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-6469-722c-b545-c7fd93d6935c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6469-722c-b545-c7fd93d6935c",
        "storage_key": "property/6767906449165635/019d7913-6469-722c-b545-c7fd93d6935c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/redrock-canyon-grill-tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5548415138276449014&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redrock-canyon-grill-tulsa",
      "poi_latitude": "36.0200535",
      "poi_longitude": "-95.9504089",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-394-7625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4414-72e7-9f64-e40d581c4a58",
        "storage_key": "property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSjkBXuRtocR9hpe5yvu_0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f89abfaa-7af1-4f98-b0c7-161dac900a51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a wide variety of delicious food, including appetizers, entrees, and cheesecakes, with options for dietary restrictions. They also highlight the beautiful decor, friendly and attentive service, and the fresh, hot food.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-679b-7699-b09e-a0a235f9150a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-679b-7699-b09e-a0a235f9150a",
        "storage_key": "property/6767906449165635/019d7913-679b-7699-b09e-a0a235f9150a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4414-72e7-9f64-e40d581c4a58",
        "storage_key": "property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e5a2dbe1-8af0-4520-bf85-33be3266a089",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Andolini's Pizzeria Jenks Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "500 Riverwalk Terrace, Jenks, OK 74037, USA",
      "poi_short_description": "Italian dishes & specialty pizzas cooked up with homemade mozzarella cheese in a bustling locale.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza, garlic knots, and other Italian dishes. They also highlight the attentive and friendly service, and the clean and comfortable atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-63f4-7766-a0d0-be29d15066f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-63f4-7766-a0d0-be29d15066f8",
        "storage_key": "property/6767906449165635/019d7913-63f4-7766-a0d0-be29d15066f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://andopizza.com/location/jenks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1451109126049549828&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andolini-s-pizzeria-jenks-riverwalk",
      "poi_latitude": "36.0268172",
      "poi_longitude": "-95.9592029",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-701-3701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4414-72e7-9f64-e40d581c4a58",
        "storage_key": "property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ35SzAGGRtocRBM6C1A9gIxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_ae8e63fa-dad9-44a6-b41d-b051f7887a03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "615 W 101st Pl S, Jenks, OK 74037, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "People say this coffee shop offers a delicious strawberry refresher and lemonade. They highlight the welcoming and friendly atmosphere, and the clean restrooms. They also like the nice and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-7387-737a-82b0-5d123ab98d0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7387-737a-82b0-5d123ab98d0f",
        "storage_key": "property/6767906449165635/019d7913-7387-737a-82b0-5d123ab98d0f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1027823",
      "poi_directions_map_url": "https://maps.google.com/?cid=16971201243391140808&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "36.01936",
      "poi_longitude": "-95.97678",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-264-4449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-bc0d-7668-8fc2-05e2f2e8c935.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-bc0d-7668-8fc2-05e2f2e8c935",
        "storage_key": "property/6767906449165635/019d7913-bc0d-7668-8fc2-05e2f2e8c935.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJs4Z1hASRtocRyCP_E53Rhes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_d05d286d-21e7-4834-bdfa-8802e23c7829",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "305 S Elm St, Jenks, OK 74037, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "People say this coffee shop offers delicious lattes, cold pours, and blended drinks, including a popular hopscotch latte and a protein mocha latte. They highlight the generous serving sizes, the option to customize drinks, and the rewards program. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-6dc2-7236-bde9-feff937e6e88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6dc2-7236-bde9-feff937e6e88",
        "storage_key": "property/6767906449165635/019d7913-6dc2-7236-bde9-feff937e6e88.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/ok/jenks/305-s.-elm-st.?y_source=1_Mjc1ODE4NTgtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10978505863414085326&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "36.0200177",
      "poi_longitude": "-95.9754546",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-bc0d-7668-8fc2-05e2f2e8c935.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-bc0d-7668-8fc2-05e2f2e8c935",
        "storage_key": "property/6767906449165635/019d7913-bc0d-7668-8fc2-05e2f2e8c935.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJoaHRz-iRtocRzvZWiep8W5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_5a70a75b-619f-46b0-bb16-fa32e8314b60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Salad and Go",
      "poi_type": "Restaurants",
      "poi_address": "604 W Main St, Jenks, OK 74037, USA",
      "poi_short_description": "Casual, vegan eatery turning out salads and wraps plus soups, burritos and protein packs.",
      "poi_long_description": "People say this restaurant offers a variety of tasty wraps, salads, and fresh drinks, including the popular Cucumber Mint. They highlight the affordable prices, convenient grab-and-go format, and healthier options compared to typical fast food. They also like the generous portions and fresh ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-772f-769f-94c8-680880579be2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-772f-769f-94c8-680880579be2",
        "storage_key": "property/6767906449165635/019d7913-772f-769f-94c8-680880579be2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.saladandgo.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=4583064181455052849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "salad-and-go",
      "poi_latitude": "36.0221525",
      "poi_longitude": "-95.9762686",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-528-8901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4414-72e7-9f64-e40d581c4a58",
        "storage_key": "property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV6-NfA6RtocRMeBxRpdQmj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "salad_shop"
    },
    {
      "id": "custom_cea2c938-267f-42b3-9bef-623f49634505",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Subway",
      "poi_type": "Restaurants",
      "poi_address": "510 S Elm St, Jenks, OK 74037, USA",
      "poi_short_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_long_description": "Some people say this sandwich shop has friendly staff.\n\nOther reviews mention the service can be slow and wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-7787-7017-8d2e-0fe05d5e301a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7787-7017-8d2e-0fe05d5e301a",
        "storage_key": "property/6767906449165635/019d7913-7787-7017-8d2e-0fe05d5e301a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://restaurants.subway.com/united-states/ok/jenks/510-south-elm-street?utm_source=yxt-goog&utm_medium=local&utm_term=acq&utm_content=39911&utm_campaign=evergreen-2020&y_source=1_MTQ5MTE2NTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15870845225630312995&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "subway",
      "poi_latitude": "36.0178234",
      "poi_longitude": "-95.9767875",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-299-3212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4414-72e7-9f64-e40d581c4a58",
        "storage_key": "property/6767906449165635/019cfb4a-4414-72e7-9f64-e40d581c4a58.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-t76lGRtocRIyrmNqWRQNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_bc88d92f-7b6f-466a-8624-a85c0c4219c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Gap Factory",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 East 103rd Street South Blding 4, Suite 4120, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-79a9-739f-a87a-81d7609a0063.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-79a9-739f-a87a-81d7609a0063",
        "storage_key": "property/6767906449165635/019d7913-79a9-739f-a87a-81d7609a0063.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gap.com/stores/ok/jenks/gap-5112.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573407974299595907&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gap-factory",
      "poi_latitude": "36.0151707",
      "poi_longitude": "-95.9630502",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-417-4779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh3aUd9qRtocRg_TM7DsBnaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_47ea5e04-313b-4449-ac0f-6eabafcb2ba5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Earthbound Trading Co.",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-7f4d-72ef-a861-06b89c2df705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7f4d-72ef-a861-06b89c2df705",
        "storage_key": "property/6767906449165635/019d7913-7f4d-72ef-a861-06b89c2df705.webp",
        "width": 1027,
        "height": 1280
      },
      "poi_business_url": "https://www.earthboundtrading.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6841694500483390919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "earthbound-trading-co",
      "poi_latitude": "36.06325",
      "poi_longitude": "-95.8821719",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-858-4391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS9GxeWSNtocRx10OO-aU8l4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_576447a9-83cb-4ca0-82b0-0e99c71adb3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Dillard's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6919 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Department store chain with apparel, shoes & accessories, plus beauty products & home goods.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, shoes, cosmetics, and fragrances. They also highlight the helpful, knowledgeable, and courteous staff, and the well-maintained store.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-8474-722e-96bf-3b4a8e7c889d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8474-722e-96bf-3b4a8e7c889d",
        "storage_key": "property/6767906449165635/019d7913-8474-722e-96bf-3b4a8e7c889d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/stores/oklahoma/woodland-hills-mall-tulsa/0792",
      "poi_directions_map_url": "https://maps.google.com/?cid=5120590491561534922&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dillard-s",
      "poi_latitude": "36.0641114",
      "poi_longitude": "-95.8817592",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-252-1890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8UooXpeNtocRyqXECez9D0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_0ddbfc0d-97c1-4372-9b87-17f5b874729d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "12200 South Waco Avenue, Glenpool, OK 74033, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, and has convenient self-checkout lanes. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the deli service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-8432-70e9-ad1c-6eb888a3facb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8432-70e9-ad1c-6eb888a3facb",
        "storage_key": "property/6767906449165635/019d7913-8432-70e9-ad1c-6eb888a3facb.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4615-glenpool-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14790108124664219266&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.9832926",
      "poi_longitude": "-96.0133594",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-299-8030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqalix2-XtocRgsY6YPoEQc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_678f56e3-d73b-4d8c-8bc2-0271b9686e33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Plaza Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8138 S Lewis Ave Suite D, Tulsa, OK 74137, USA",
      "poi_short_description": "Shopping venue offering a variety of food options, from coffee to Thai cuisine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-8fd8-763b-9247-f67085501f6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8fd8-763b-9247-f67085501f6e",
        "storage_key": "property/6767906449165635/019d7913-8fd8-763b-9247-f67085501f6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7543565869580090407&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "plaza-shopping-center",
      "poi_latitude": "36.0451269",
      "poi_longitude": "-95.95801860000002",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU9qpWMGTtocRJ_wU3DAhsGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_01daccc5-d2a9-4ce2-8f6f-82772a039aa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Kings Landing",
      "poi_type": "Shopping & Retail",
      "poi_address": "9914 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Shopping mall with a variety of restaurants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-9076-73fc-896e-c6a2c4f234ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9076-73fc-896e-c6a2c4f234ab",
        "storage_key": "property/6767906449165635/019d7913-9076-73fc-896e-c6a2c4f234ab.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.kingslandingtulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1228212591620793637&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kings-landing",
      "poi_latitude": "36.0204183",
      "poi_longitude": "-95.949943",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-496-2865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ601O3nqRtocRJSU4QNh8CxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9e7a7a82-d239-44bd-ba52-e8bb9a85c229",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Riverside Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "S Delaware Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Chain store stocking low-priced goods such as cleaning supplies, school products and greeting cards.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-9398-751f-b04d-533ffa13cd71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9398-751f-b04d-533ffa13cd71",
        "storage_key": "property/6767906449165635/019d7913-9398-751f-b04d-533ffa13cd71.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://retailproperties.cbre.us/p/retail-real-estate-listings/Tulsa-OK-74137/riversidemarket#highlights",
      "poi_directions_map_url": "https://maps.google.com/?cid=12091721736926000664&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverside-market",
      "poi_latitude": "36.025083",
      "poi_longitude": "-95.9480904",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlzIKAn2RtocRGPZX5Npszqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4558949c-9c9d-474d-b5d1-0b1680bd9819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "8880 S Delaware Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers excellent customer service and helpful, friendly employees. They also highlight the efficient rental process and the well-maintained equipment.\n\nSome reviews mention the customer service at the self-checkout can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-96f0-74da-bc85-389c5b342a64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-96f0-74da-bc85-389c5b342a64",
        "storage_key": "property/6767906449165635/019d7913-96f0-74da-bc85-389c5b342a64.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/SW-Tulsa/OK/Tulsa/74137/3915?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2527364477607948508&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.0344313",
      "poi_longitude": "-95.9516071",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-299-3028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv29RrNCTtocR3DDDEZoAEyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_08f0b4d0-6eb0-4e2b-9026-f4965fefdc45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "7437 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of Christmas gifts and other items. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the self-checkout experience can be negative.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-9b66-73e4-9499-d16fee90ee8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9b66-73e4-9499-d16fee90ee8c",
        "storage_key": "property/6767906449165635/019d7913-9b66-73e4-9499-d16fee90ee8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/tulsa-hills/2357",
      "poi_directions_map_url": "https://maps.google.com/?cid=14723074754401008891&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.05510510000001",
      "poi_longitude": "-96.0010747",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-877-1620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4434-7749-a04c-74fa13f0ee93",
        "storage_key": "property/6767906449165635/019cfb4a-4434-7749-a04c-74fa13f0ee93.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJehAT4KVtocR-_yXoXveUsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_37d331f8-791c-4722-bd37-eeebc003bb87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "South Lakes Golf Course",
      "poi_type": "Entertainment",
      "poi_address": "9253 S Elwood Ave, Jenks, OK 74037, USA",
      "poi_short_description": "Public golf course featuring 18 holes, plus a driving range, putting green, and a grill.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-9e3e-768d-a692-912142a3294a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9e3e-768d-a692-912142a3294a",
        "storage_key": "property/6767906449165635/019d7913-9e3e-768d-a692-912142a3294a.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "http://www.southlakesgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2042679353067249268&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "south-lakes-golf-course",
      "poi_latitude": "36.0308645",
      "poi_longitude": "-95.9930022",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-746-3760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4447-7368-b139-854cc59a3fe7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4447-7368-b139-854cc59a3fe7",
        "storage_key": "property/6767906449165635/019cfb4a-4447-7368-b139-854cc59a3fe7.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJDSpZTAOUtocRdB6ZjQwOWRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_15bbb9f6-4a69-47fd-81a7-1e43efce77c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Jenks Planetarium",
      "poi_type": "Entertainment",
      "poi_address": "321 N 2nd St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-9ddf-75bb-8d75-b495898a3fe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9ddf-75bb-8d75-b495898a3fe9",
        "storage_key": "property/6767906449165635/019d7913-9ddf-75bb-8d75-b495898a3fe9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.jenksps.ce.eleyo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15864267425793977827&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-planetarium",
      "poi_latitude": "36.026232",
      "poi_longitude": "-95.9688664",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-299-4415 ext. 3307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4249-74db-82e7-60636e2d10a4",
        "storage_key": "property/6767906449165635/019cfb4a-4249-74db-82e7-60636e2d10a4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl3rZvNqRtocR4y1A2CszKdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "planetarium"
    },
    {
      "id": "custom_ecfe1beb-2369-421e-bfb0-877c2f2a2e4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Tulsa Botanic Garden",
      "poi_type": "Entertainment",
      "poi_address": "3900 Tulsa Botanic Dr, Tulsa, OK 74127, USA",
      "poi_short_description": "Botanic garden with floral terraces, a lakeside promenade, lotus pool & prairie trail, plus events.",
      "poi_long_description": "People say this botanical garden offers beautiful gardens, water features, sculptures, and a variety of flora, including flowers, trees, and shrubs. They highlight the peaceful and relaxing vibe, and the family-friendly and educational experience. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-a158-744e-ab8d-d53dfafd694a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a158-744e-ab8d-d53dfafd694a",
        "storage_key": "property/6767906449165635/019d7913-a158-744e-ab8d-d53dfafd694a.webp",
        "width": 1280,
        "height": 704
      },
      "poi_business_url": "https://www.tulsabotanic.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15418899865116188645&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-botanic-garden",
      "poi_latitude": "36.2068636",
      "poi_longitude": "-96.0621357",
      "poi_miles_from_property": "19.4 mi",
      "poi_walking_minutes": "7 hours 8 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 918-289-0330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4418-70e9-af65-31e3f6ef96d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4418-70e9-af65-31e3f6ef96d1",
        "storage_key": "property/6767906449165635/019cfb4a-4418-70e9-af65-31e3f6ef96d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZRo6nvrtocR5Z-RB7zv-tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_9114cc38-f5ff-48e7-b298-f0fb71683e3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Greenwood Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "322 N Greenwood Ave, Tulsa, OK 74120, USA",
      "poi_short_description": "This cultural center offers exhibits on local African-American heritage & educational programs.",
      "poi_long_description": "Visitors say this cultural center hosts a variety of events and features a museum with exhibits on the history of Greenwood, including the Greenwood Uprising. They also highlight the knowledgeable and informative staff, and the powerful and emotional experience of learning about this history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-afcc-76a6-8b8e-3ad263d34574.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-afcc-76a6-8b8e-3ad263d34574",
        "storage_key": "property/6767906449165635/019d7913-afcc-76a6-8b8e-3ad263d34574.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.greenwoodculturalcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3505075906757213506&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "greenwood-cultural-center",
      "poi_latitude": "36.1619444",
      "poi_longitude": "-95.9872222",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-596-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4418-70e9-af65-31e3f6ef96d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4418-70e9-af65-31e3f6ef96d1",
        "storage_key": "property/6767906449165635/019cfb4a-4418-70e9-af65-31e3f6ef96d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzyoPIHrtocRQj0LbfeHpDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_0920670a-4c4f-475c-8aa2-bee3a259f167",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-a59e-779d-bf87-c3f2966e3bee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a59e-779d-bf87-c3f2966e3bee",
        "storage_key": "property/6767906449165635/019d7913-a59e-779d-bf87-c3f2966e3bee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "17.1 mi",
      "poi_walking_minutes": "6 hours 21 mins",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4418-70e9-af65-31e3f6ef96d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4418-70e9-af65-31e3f6ef96d1",
        "storage_key": "property/6767906449165635/019cfb4a-4418-70e9-af65-31e3f6ef96d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_9d6d6667-1e84-46af-a9d2-b756779b184f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "Tulsa Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "110 E 2nd St S, Tulsa, OK 74103, USA",
      "poi_short_description": "6 venues presenting dance, theater, music & other programs by local & visiting artists.",
      "poi_long_description": "People say this performing arts theater offers a variety of shows, including Broadway productions, local theater, ballet, and concerts. They highlight the excellent acoustics, comfortable seating, and good sightlines from most seats. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019d7913-ab74-75da-90ad-5bf8aa4d3dde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ab74-75da-90ad-5bf8aa4d3dde",
        "storage_key": "property/6767906449165635/019d7913-ab74-75da-90ad-5bf8aa4d3dde.webp",
        "width": 821,
        "height": 313
      },
      "poi_business_url": "http://www.tulsapac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1663529134971770182&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-performing-arts-center",
      "poi_latitude": "36.154635",
      "poi_longitude": "-95.989282",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-596-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-4418-70e9-af65-31e3f6ef96d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-4418-70e9-af65-31e3f6ef96d1",
        "storage_key": "property/6767906449165635/019cfb4a-4418-70e9-af65-31e3f6ef96d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmblR2HjrtocRRlWBO-8KFhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_3cf620ab-aa51-4445-abfb-bd7fd8c6f13d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "poi_name": "The Cape Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "the-cape-brewing-company",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9a763bd081348a56c9a5e4a9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bb2398dba6157218e191c04b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e8be2b95ba282c88153e0e93",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fe9dcd7f30f4ae9e7ebd744a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6392b5266752b66af037f84c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_801a8417ffe6d9a287ee5aa3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a33d745f-9bc3-422a-8072-698c08a07073",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "rating": "5.0",
      "name": "Dave Reber Jr",
      "text": "The apartment management was fast to submit the request for maintenance.  The gentleman who came to do the maintenance came prepared with the right tools and part.  All was done quickly and professionally.",
      "date": "2025-10-08",
      "title": ""
    },
    {
      "id": "custom_0e076c06-0914-435f-a88e-65d1a49a1c8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "rating": "5.0",
      "name": "Jaidi Castro",
      "text": "I had such an amazing experience just with the moving in process the office and maintenance team reassured me that the apartment was in a presten condition and the office team made sure I was well informed.",
      "date": "2025-08-13",
      "title": ""
    },
    {
      "id": "custom_ca6dbdd3-da7f-4112-bbad-d354ca886f6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "rating": "5.0",
      "name": "Megan Choat",
      "text": "I lived here for about three years and didn’t have a bad experience, although I wasn’t initially informed about the one carpet cleaning at lease renewal when I asked I was immediately placed on the waiting list. I do wish they would adapt wood flooring for at least the living room area. Maintenance was prompt and fixed any issues that were reported. Office staff was helpful whenever I reached out. the apartment units were clean and spacious I had a two bedroom and was comfortable.",
      "date": "2025-02-23",
      "title": ""
    },
    {
      "id": "custom_d8fa848e-9f8e-4045-bf5a-6937deebd31d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "rating": "5.0",
      "name": "Nagesh Ramakrishna",
      "text": "I've had a great experience living here. The leasing office staff is friendly and always responds to queries within a reasonable time. The apartment is neat, clean, and well-maintained—perfect for anyone looking for a peaceful place to stay.",
      "date": "2025-04-07",
      "title": ""
    },
    {
      "id": "custom_1114c314-c3a5-46fc-a45c-fc46eea547b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "rating": "5.0",
      "name": "Laura Gibbs",
      "text": "It’s been wonderful so far! The moving process has been quick and easy. It’s been very peaceful and conveniently located near many restaurants, grocery stores, and shopping areas !",
      "date": "2025-08-12",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_bff8aebf-25da-4056-a532-b9ae08041508",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-9b0d-7648-b1d5-b1d6b345030c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a swimming pool and lounge chairs at an apartment complex.",
        "public_id": "019cfb4a-9b0d-7648-b1d5-b1d6b345030c",
        "storage_key": "property/6767906449165635/019cfb4a-9b0d-7648-b1d5-b1d6b345030c.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Reserve at Elm Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f478ee6d051c2539fa66278"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-75cb-7219-ace7-c45eaab4c781",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-reserve-at-elm",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635"
    },
    {
      "lead_collector_id": "019cf79e-7643-729f-a539-9eb29a06e709",
      "lead_source": "LANDING_PAGE",
      "name": "the-reserve-at-elm",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "generator",
      "page_item_url": "apartments-with-pool-jenks-ok-reserve-at-elm",
      "search_query": "apartments with pool Jenks OK",
      "category": "Amenity",
      "h1_title": "Best Apartments with Pool in Jenks, OK",
      "h2_subtitle": "Discover luxury living at apartments with a pool in Jenks, OK. The Reserve at Elm offers modern amenities in a prime location.",
      "page_copy": "Experience the ultimate comfort in stylish apartments with pool access in Jenks, OK at The Reserve at Elm. Our community boasts a sparkling resort-style pool perfect for relaxing or socializing with neighbors. It’s just one of the many luxurious amenities you will find here.\n\nNestled in the vibrant city of Jenks, The Reserve at Elm offers not only a fantastic pool but also spacious one and two-bedroom floor plans. Living here means enjoying a fitness center, pet play area, and more – all within a secure gated community. Schedule a tour today and see why so many call The Reserve home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool and outdoor grills with seating areas at apartment complex",
        "public_id": "019cfb4a-1736-717e-8165-e0a347616b26",
        "storage_key": "property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Jenks, OK",
      "seo_description": "Discover The Reserve at Elm, Jenks OK. Luxurious apartments with a pool, fitness center, and more. Perfect for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-jenks-reserve-at-elm",
      "search_query": "dog park apartments near Jenks",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near Jenks",
      "h2_subtitle": "Explore dog park apartments near Jenks. The Reserve at Elm offers a pet-friendly community with a dedicated pet play area.",
      "page_copy": "For those seeking dog park apartments near Jenks, The Reserve at Elm is the perfect home. Located just a stone's throw away, this community welcomes pets and includes a dedicated pet play area where your furry friends can roam and play freely.\n\nBeyond the pet-friendly amenities, The Reserve at Elm provides residents with one and two-bedroom options featuring modern designs and luxurious touches like tile floors and fireplaces. The community also includes resort-style extras such as a pool and fitness center, promising a complete and enjoyable living experience in Jenks, Oklahoma.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool and outdoor grills with seating areas at apartment complex",
        "public_id": "019cfb4a-1736-717e-8165-e0a347616b26",
        "storage_key": "property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near Jenks",
      "seo_description": "Find your pet-friendly home at The Reserve at Elm, near Jenks, with a pet play area and luxurious living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-jenks-reserve-at-elm",
      "search_query": "luxury apartments with in-unit laundry Jenks",
      "category": "Amenity",
      "h1_title": "Luxury Apartments in Jenks with In-Unit Laundry",
      "h2_subtitle": "Discover luxury apartments with in-unit laundry in Jenks. The Reserve at Elm offers top-tier amenities for modern living.",
      "page_copy": "Experience the convenience of luxury apartments with in-unit laundry in Jenks at The Reserve at Elm. Our beautifully designed one and two-bedroom floor plans make sophisticated living a breeze. Besides in-unit amenities, residents enjoy exclusive access to facilities such as a shimmering pool and a state-of-the-art fitness center.\n\nOur community in Jenks, Oklahoma, is crafted for those who seek elegance and functionality. Indulge in lifestyle upgrades with fireplaces, tile floors, and a gated environment ensuring peace of mind. Schedule a tour today and make The Reserve at Elm your new luxurious home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool and outdoor grills with seating areas at apartment complex",
        "public_id": "019cfb4a-1736-717e-8165-e0a347616b26",
        "storage_key": "property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry in Jenks",
      "seo_description": "Explore The Reserve at Elm in Jenks for luxury living with in-unit laundry, plus great amenities like a pool and fitness center.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "generator",
      "page_item_url": "pet-friendly-community-tulsa-county-reserve-at-elm",
      "search_query": "pet-friendly community in Tulsa County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Community in Tulsa County",
      "h2_subtitle": "Discover our pet-friendly community in Tulsa County. The Reserve at Elm offers amenities that cater to both you and your furry companions.",
      "page_copy": "Welcome to The Reserve at Elm, a leading pet-friendly community in Tulsa County. Here, you'll find a delightful environment where pets are not just welcome but cherished. Our dedicated pet play area allows your furry friends to frolic and socialize while you relax and unwind.\n\nLocated in the vibrant area of Jenks, Oklahoma, The Reserve at Elm combines luxurious amenities with pet-friendly convenience. Residents enjoy modern one and two-bedroom floor plans with features like fireplaces and tile floors, as well as community perks such as a sparkling pool and fitness center. Visit us today and see why The Reserve is a premier choice for pet owners.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool and outdoor grills with seating areas at apartment complex",
        "public_id": "019cfb4a-1736-717e-8165-e0a347616b26",
        "storage_key": "property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Community in Tulsa County",
      "seo_description": "Join The Reserve at Elm, a pet-friendly community in Tulsa County, featuring spacious apartments and a dedicated pet play area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "generator",
      "page_item_url": "gated-apartments-fitness-center-74037-reserve-at-elm",
      "search_query": "gated apartments with fitness center near 74037",
      "category": "Amenity",
      "h1_title": "Gated Apartments with Fitness Center Near 74037",
      "h2_subtitle": "Explore gated apartments with a fitness center near 74037. The Reserve at Elm offers secure living with top amenities.",
      "page_copy": "Discover a new standard of living at The Reserve at Elm, offering gated apartments with a fitness center near the 74037 area. Our community combines security with convenience, providing residents with peace of mind and a vibrant lifestyle. \n\nThe Reserve at Elm, located in Jenks, Oklahoma, features meticulously designed one and two-bedroom floor plans set within a secure enclave. Enjoy unparalleled amenities, including a shimmering pool, a well-equipped fitness center, tile floors, and cozy fireplaces, all aimed at enhancing your daily life. Come see why The Reserve at Elm is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool and outdoor grills with seating areas at apartment complex",
        "public_id": "019cfb4a-1736-717e-8165-e0a347616b26",
        "storage_key": "property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Apartments with Fitness Center Near 74037",
      "seo_description": "Live at The Reserve at Elm near 74037, offering gated security and a fitness center, along with luxury features and amenities tailored to your lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-jenks-ok-reserve-at-elm",
      "search_query": "one bedroom apartments jenks ok",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Jenks, OK",
      "h2_subtitle": "Explore stylish one bedroom apartments in Jenks, OK at The Reserve at Elm. Enjoy modern amenities and a prime location.",
      "page_copy": "Welcome to The Reserve at Elm, where you can find exquisite one bedroom apartments in Jenks, OK. Each apartment is designed with modern flair and functional living spaces ideal for singles or couples. Our one-bedroom layouts provide comfort and style, complete with premium finishes.\n\nLocated in beautiful Jenks, Oklahoma, The Reserve at Elm offers more than just a place to reside—it’s a lifestyle. Residents enjoy access to amenities such as a sparkling pool, state-of-the-art fitness center, and a vibrant pet play area. With fireplaces and tile floors, our apartments are crafted for your comfort. Schedule a tour today to experience The Reserve at Elm.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool and outdoor grills with seating areas at apartment complex",
        "public_id": "019cfb4a-1736-717e-8165-e0a347616b26",
        "storage_key": "property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Jenks, OK",
      "seo_description": "Discover one bedroom apartments at The Reserve at Elm in Jenks, OK. Stylish living with a pool, fitness center, and more amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165635",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-74037-reserve-at-elm",
      "search_query": "two bedroom apartments near 74037",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 74037",
      "h2_subtitle": "Find spacious two bedroom apartments near 74037 at The Reserve at Elm. Experience modern living with premium amenities.",
      "page_copy": "At The Reserve at Elm, discover the perfect blend of space and style with our two bedroom apartments near 74037. Each apartment is meticulously designed, offering ample living areas and modern finishes ideal for families, roommates, or individuals seeking extra room.\n\nNestled in Jenks, Oklahoma, The Reserve at Elm is more than just a place to live; it's a community. Enjoy access to a range of top-notch amenities, including a refreshing pool, a fully-equipped fitness center, and dedicated pet play areas. Our gated community ensures comfort and security, making it a perfect choice for those looking to settle near the 74037 area. Visit today to find your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool and outdoor grills with seating areas at apartment complex",
        "public_id": "019cfb4a-1736-717e-8165-e0a347616b26",
        "storage_key": "property/6767906449165635/019cfb4a-1736-717e-8165-e0a347616b26.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 74037",
      "seo_description": "Explore two bedroom apartments at The Reserve at Elm near 74037. Enjoy modern designs, a pool, fitness center, and more within a gated community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5208"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-BNBYXCQW8E"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151487"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/reserve-at-elm/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PTB4MWBD"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165635/019d1bda-7c51-72da-b193-a90c94bed3f0.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "6f4b4db4-5c96-46ba-ae7f-9543494ef4c3"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-869-6816"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651db79c85c8619436062d"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjRnWXdhSlEwUTVLTkZxREdtRG5EcFE9PSIsInZhbHVlIjoicXQvWWoxdGtVem5TZVd1cERWb25wZz09IiwibWFjIjoiMWYwYjk1YjNmM2E5OWU0NmUwNTcxMzA2NjRjZjNjYzAyMGNkZGVjMGVmMTdkMDJjMDczYjYzNjBlNjcxYzdkMyJ9"
    }
  ],
  "custom_qb_id": "5208",
  "custom_ga4_id": "G-BNBYXCQW8E",
  "custom_repli_id": "10041151487",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/reserve-at-elm/register/",
  "custom_google_gtm_id": "GTM-PTB4MWBD",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165635/019d1bda-7c51-72da-b193-a90c94bed3f0.pdf",
  "custom_rentgrata_property_id": "6f4b4db4-5c96-46ba-ae7f-9543494ef4c3",
  "custom_ppc_tracking_phone_number": "888-869-6816",
  "custom_residentboost_apartment_id": "64651db79c85c8619436062d",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjRnWXdhSlEwUTVLTkZxREdtRG5EcFE9PSIsInZhbHVlIjoicXQvWWoxdGtVem5TZVd1cERWb25wZz09IiwibWFjIjoiMWYwYjk1YjNmM2E5OWU0NmUwNTcxMzA2NjRjZjNjYzAyMGNkZGVjMGVmMTdkMDJjMDczYjYzNjBlNjcxYzdkMyJ9"
};

export const generatedAt = '2026-08-27T21:35:41.126Z';
